export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BannerId: { input: any; output: any; }
  ChallengeId: { input: any; output: any; }
  CollectionId: { input: any; output: any; }
  CollectionListId: { input: any; output: any; }
  ConceptId: { input: any; output: any; }
  DocumentId: { input: any; output: any; }
  ExerciseId: { input: any; output: any; }
  ISODateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  LessonGroupId: { input: any; output: any; }
  LessonId: { input: any; output: any; }
  LessonScheduleId: { input: any; output: any; }
  LessonSectionId: { input: any; output: any; }
  LessonSectionTemplateId: { input: any; output: any; }
  LinkId: { input: any; output: any; }
  PlanId: { input: any; output: any; }
  PlanSectionId: { input: any; output: any; }
  ProgressivePlanBlockId: { input: any; output: any; }
  ProgressivePlanId: { input: any; output: any; }
  ProgressivePlanInstanceId: { input: any; output: any; }
  ProgressivePlanScheduleWorkoutId: { input: any; output: any; }
  ProgressivePlanWeekId: { input: any; output: any; }
  ProgressivePlanWorkoutId: { input: any; output: any; }
  ResourceId: { input: any; output: any; }
  ResourceListId: { input: any; output: any; }
  ResourceSectionId: { input: any; output: any; }
  SectionExerciseGroupId: { input: any; output: any; }
  SectionExerciseGroupTemplateId: { input: any; output: any; }
  SectionExerciseId: { input: any; output: any; }
  SectionExerciseTemplateId: { input: any; output: any; }
  SubtitleGenerationJobId: { input: any; output: any; }
  SubtitleId: { input: any; output: any; }
  TagId: { input: any; output: any; }
  URL: { input: any; output: any; }
};

export type AllProgressivePlanInstancesFilter = {
  /** Gym ID (admin only, users default to their own gym) */
  gymId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProgressivePlanInstanceStatus>;
};

export type AssignUserToGymInput = {
  gym: GymInput;
  user: UserInput;
};

export type Banner = {
  __typename?: 'Banner';
  activeFrom: Scalars['ISODateTime']['output'];
  activeTo: Scalars['ISODateTime']['output'];
  description: Scalars['String']['output'];
  gymStructures: Array<GymStructure>;
  id: Scalars['BannerId']['output'];
  image: Image;
  link?: Maybe<Scalars['String']['output']>;
  mobileImage?: Maybe<Image>;
  title: Scalars['String']['output'];
};

export type BannerCondition = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  gymStructures?: InputMaybe<Array<GymStructure>>;
};

export enum BannerOrder {
  ACTIVE_FROM = 'ACTIVE_FROM',
  ACTIVE_TO = 'ACTIVE_TO',
  CREATED_AT = 'CREATED_AT'
}

export type CancelProgressivePlanInput = {
  progressivePlanInstanceId: Scalars['ProgressivePlanInstanceId']['input'];
};

export type Challenge = {
  __typename?: 'Challenge';
  challengeImage?: Maybe<Image>;
  challengeType: ChallengeType;
  createdAt: Scalars['ISODateTime']['output'];
  ctaImage?: Maybe<Image>;
  id: Scalars['ChallengeId']['output'];
  lesson?: Maybe<Lesson>;
  longDescription?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  resourcePage?: Maybe<Resource>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISODateTime']['output'];
};

export type ChallengeCondition = {
  challengeType?: InputMaybe<Array<ChallengeType>>;
  lesson?: InputMaybe<LessonInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ChallengeOrderBy {
  CREATED_AT = 'CREATED_AT',
  TITLE = 'TITLE'
}

export enum ChallengeType {
  CALORIES = 'CALORIES',
  DISTANCE = 'DISTANCE',
  REPS = 'REPS',
  TIME = 'TIME',
  WEIGHT = 'WEIGHT'
}

export enum ClassType {
  GROUPEX = 'GROUPEX',
  OPENGYM = 'OPENGYM'
}

export type Collection = {
  __typename?: 'Collection';
  bannerImage?: Maybe<Image>;
  collectionList?: Maybe<CollectionList>;
  condition?: Maybe<Scalars['JSON']['output']>;
  ctaImage?: Maybe<Image>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['CollectionId']['output'];
  lessons?: Maybe<Array<Lesson>>;
  longDescription?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Resource>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type CollectionLessonsArgs = {
  filter?: InputMaybe<LessonCondition>;
};

export type CollectionCondition = {
  lessonIds?: InputMaybe<Array<LessonInput>>;
};

export type CollectionInput = {
  id: Scalars['CollectionId']['input'];
};

export type CollectionList = {
  __typename?: 'CollectionList';
  collections?: Maybe<Array<Collection>>;
  id: Scalars['CollectionListId']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CollectionListInput = {
  id: Scalars['CollectionListId']['input'];
};

export enum CollectionListOrderBy {
  CREATED_AT = 'CREATED_AT'
}

export enum CollectionOrderBy {
  CREATED_AT = 'CREATED_AT',
  TITLE = 'TITLE'
}

export type CollectionWithDisplayOrderInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['CollectionId']['input'];
};

export type CompleteLessonByIdInput = {
  user: UserInput;
};

export enum ComponentAlignment {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL'
}

export type Concept = {
  __typename?: 'Concept';
  hiddenConcept: Scalars['Boolean']['output'];
  id: Scalars['ConceptId']['output'];
  name: Scalars['String']['output'];
};

export type ConceptCondition = {
  includeHiddenConcepts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConceptInput = {
  id: Scalars['ConceptId']['input'];
};

export enum CountryCode {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW'
}

export type CreateBannerInput = {
  activeFrom: Scalars['ISODateTime']['input'];
  activeTo: Scalars['ISODateTime']['input'];
  description: Scalars['String']['input'];
  gymStructures?: InputMaybe<Array<GymStructure>>;
  image: ImageInput;
  link?: InputMaybe<Scalars['String']['input']>;
  mobileImage?: InputMaybe<ImageInput>;
  title: Scalars['String']['input'];
};

export type CreateChallengeInput = {
  challengeImage?: InputMaybe<ImageInput>;
  challengeType: ChallengeType;
  ctaImage?: InputMaybe<ImageInput>;
  lesson?: InputMaybe<LessonInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resourcePage?: InputMaybe<ResourceInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateCollectionInput = {
  bannerImage?: InputMaybe<ImageInput>;
  collectionList?: InputMaybe<CollectionListInput>;
  condition?: InputMaybe<CollectionCondition>;
  ctaImage?: InputMaybe<ImageInput>;
  lessons?: InputMaybe<Array<LessonInput>>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<ResourceInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateCollectionListInput = {
  collections?: InputMaybe<Array<CollectionWithDisplayOrderInput>>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateConceptInput = {
  hiddenConcept?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  keyName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateEquipmentInput = {
  name: Scalars['String']['input'];
};

export type CreateExerciseInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  equipment?: InputMaybe<EquipmentInput>;
  name: Scalars['String']['input'];
  video?: InputMaybe<VideoInput>;
};

export type CreateGymInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<CountryCode>;
  equipment?: InputMaybe<Array<EquipmentInput>>;
  gymStructure?: InputMaybe<GymStructureInput>;
  gymType?: InputMaybe<GymTypeInput>;
  name: Scalars['String']['input'];
  preferredLanguage?: InputMaybe<LanguageInput>;
  /** @deprecated Use gymStructure instead. This field is kept for backward compatibility only. */
  structure?: InputMaybe<GymStructure>;
};

export type CreateGymStructureInput = {
  name: Scalars['String']['input'];
};

export type CreateGymTypeInput = {
  name: Scalars['String']['input'];
};

export type CreateImageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  keyName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateLanguageInput = {
  code: Scalars['String']['input'];
  image?: InputMaybe<ImageInput>;
  name: Scalars['String']['input'];
  resourceTranslationAutomated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateLessonGroupInput = {
  lessons: Array<LessonInput>;
  weekInfo?: InputMaybe<LessonGroupWeekInfoInput>;
};

export type CreateLessonInput = {
  apiOnly?: InputMaybe<Scalars['Boolean']['input']>;
  classType?: InputMaybe<ClassType>;
  collectionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  concept?: InputMaybe<ConceptInput>;
  description: Scalars['String']['input'];
  equipment?: InputMaybe<Array<EquipmentInput>>;
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  image?: InputMaybe<ImageInput>;
  intensity: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  publishedAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type CreateLessonScheduleInput = {
  lesson: LessonInput;
  scheduledAt: Scalars['ISODateTime']['input'];
};

export type CreateLessonSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<LessonSectionFormat>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  isRotational?: InputMaybe<Scalars['Boolean']['input']>;
  lesson: LessonInput;
  lessonSectionTemplate?: InputMaybe<LessonSectionTemplateInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  restTime?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  video?: InputMaybe<VideoInput>;
  workTime?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLessonSectionTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayDescription?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  format: LessonSectionFormat;
  hideDescriptionField?: InputMaybe<Scalars['Boolean']['input']>;
  hideTitleField?: InputMaybe<Scalars['Boolean']['input']>;
  hideWorkRestField?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  restTime?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  workTime?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLinkInput = {
  url: Scalars['URL']['input'];
};

export type CreatePlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ImageInput>;
  title: Scalars['String']['input'];
};

export type CreatePlanSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  lessonIds?: InputMaybe<Array<Scalars['LessonId']['input']>>;
  planId?: InputMaybe<Scalars['PlanId']['input']>;
  sectionDuration: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type CreateProgressivePlanBlockInput = {
  desktopImage?: InputMaybe<ImageInput>;
  displayOrder: Scalars['Int']['input'];
  introText?: InputMaybe<Scalars['String']['input']>;
  introVideo?: InputMaybe<VideoInput>;
  mobileImage?: InputMaybe<ImageInput>;
  name: Scalars['String']['input'];
  progressivePlan?: InputMaybe<ProgressivePlanInput>;
  weeks?: InputMaybe<Array<CreateProgressivePlanWeekInput>>;
};

export type CreateProgressivePlanInput = {
  bannerImage?: InputMaybe<ImageInput>;
  ctaImage?: InputMaybe<ImageInput>;
  isPromoted?: InputMaybe<Scalars['Boolean']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overviewVideo?: InputMaybe<VideoInput>;
  progressivePlanBlocks?: InputMaybe<Array<CreateProgressivePlanBlockInput>>;
  resource?: InputMaybe<ResourceInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  startAvailableAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  status?: InputMaybe<ProgressivePlanStatus>;
};

export type CreateProgressivePlanWeekInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  progressivePlanBlock?: InputMaybe<ProgressivePlanBlockInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  weekNumber: Scalars['Int']['input'];
  workouts?: InputMaybe<Array<CreateProgressivePlanWorkoutInput>>;
};

export type CreateProgressivePlanWorkoutInput = {
  dayOfWeek: Scalars['Int']['input'];
  lesson?: InputMaybe<LessonInput>;
  progressivePlanWeek?: InputMaybe<ProgressivePlanWeekInput>;
};

export type CreateResourceInput = {
  content: Scalars['String']['input'];
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  image: ImageInput;
  title: Scalars['String']['input'];
};

export type CreateResourceListInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  image?: InputMaybe<ImageInput>;
  resourceLists?: InputMaybe<Array<ResourceListInput>>;
  resources?: InputMaybe<Array<ResourceInput>>;
  title: Scalars['String']['input'];
};

export type CreateResourceSectionInput = {
  componentAlignment?: InputMaybe<ComponentAlignment>;
  content?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<DocumentInput>>;
  images?: InputMaybe<Array<ImageInput>>;
  links?: InputMaybe<Array<LinkInput>>;
  resource?: InputMaybe<ResourceInput>;
  title: Scalars['String']['input'];
  videos?: InputMaybe<Array<VideoInput>>;
};

export type CreateSectionExerciseGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  lessonSection?: InputMaybe<LessonSectionInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  parentSectionExerciseGroup?: InputMaybe<SectionExerciseGroupInput>;
  repeatTimes?: InputMaybe<Scalars['Int']['input']>;
  sectionExerciseGroupTemplate?: InputMaybe<SectionExerciseGroupTemplateInput>;
  sectionExerciseGroups?: InputMaybe<Array<SectionExerciseGroupWithDisplayOrderInput>>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSectionExerciseGroupTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayDescription?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  format: LessonSectionFormat;
  hideDescriptionField?: InputMaybe<Scalars['Boolean']['input']>;
  hideTitleField?: InputMaybe<Scalars['Boolean']['input']>;
  lessonSectionTemplate?: InputMaybe<LessonSectionTemplateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentSectionExerciseGroupTemplate?: InputMaybe<SectionExerciseGroupTemplateInput>;
  sectionExerciseGroupTemplates?: InputMaybe<Array<SectionExerciseGroupTemplateInput>>;
};

export type CreateSectionExerciseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  exercise: ExerciseInput;
  group?: InputMaybe<SectionExerciseGroupInput>;
  maxDistance?: InputMaybe<Scalars['Float']['input']>;
  maxRepetitions?: InputMaybe<Scalars['Float']['input']>;
  maxWeight?: InputMaybe<Scalars['Float']['input']>;
  minDistance?: InputMaybe<Scalars['Float']['input']>;
  minRepetitions?: InputMaybe<Scalars['Float']['input']>;
  minWeight?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rpe?: InputMaybe<Scalars['Int']['input']>;
  singleDistance?: InputMaybe<Scalars['Float']['input']>;
  singleRepetitions?: InputMaybe<Scalars['Float']['input']>;
  singleWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateSectionExerciseTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exercise?: InputMaybe<ExerciseInput>;
  sectionExerciseGroupTemplate?: InputMaybe<SectionExerciseGroupTemplateInput>;
};

export type CreateSubtitleGenerationJobInput = {
  videoId: Scalars['Int']['input'];
};

export type CreateSubtitleInput = {
  keyName?: InputMaybe<Scalars['String']['input']>;
  language: LanguageInput;
  video: VideoInput;
};

export type CreateTagInput = {
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gym: GymInput;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<LanguageInput>;
  profileImage?: InputMaybe<ImageInput>;
  type: UserType;
  userRole?: InputMaybe<UserRole>;
};

export type CreateVideoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  keyName?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<ImageInput>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type DateRange = {
  from?: InputMaybe<Scalars['ISODateTime']['input']>;
  to?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type Document = {
  __typename?: 'Document';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['DocumentId']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['URL']['output']>;
  uploadDetails?: Maybe<MediaUploadDetails>;
};


export type DocumentUploadDetailsArgs = {
  extension: DocumentFileExtensions;
};

export type DocumentCondition = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export enum DocumentFileExtensions {
  PDF = 'PDF'
}

export type DocumentInput = {
  id: Scalars['DocumentId']['input'];
};

export type DurationRange = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type Equipment = {
  __typename?: 'Equipment';
  id: Scalars['Int']['output'];
  lessons?: Maybe<Array<Lesson>>;
  name: Scalars['String']['output'];
};

export type EquipmentInput = {
  id: Scalars['Int']['input'];
};

export type Exercise = {
  __typename?: 'Exercise';
  active: Scalars['Boolean']['output'];
  alternativeExercises?: Maybe<Array<Exercise>>;
  description: Scalars['String']['output'];
  /** @deprecated No longer supported */
  duration?: Maybe<Scalars['Float']['output']>;
  equipment?: Maybe<Equipment>;
  id: Scalars['ExerciseId']['output'];
  name: Scalars['String']['output'];
  video?: Maybe<Video>;
};

export type ExerciseCondition = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseInput = {
  id: Scalars['ExerciseId']['input'];
};

export enum FileType {
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  SUBTITLE = 'SUBTITLE',
  VIDEO = 'VIDEO'
}

export type Gym = {
  __typename?: 'Gym';
  /** Whether the gym (and all its PTs) is active or disabled */
  active: Scalars['Boolean']['output'];
  activeProgressivePlans: Array<ProgressivePlanInstance>;
  country?: Maybe<CountryCode>;
  equipment?: Maybe<Array<Equipment>>;
  gymStructure?: Maybe<GymStructureTable>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  preferredLanguage?: Maybe<Language>;
  /**
   * @deprecated Use gymStructure instead. This field is kept for backward compatibility only.
   * @deprecated Use gymStructure instead. This field is kept for backward compatibility only.
   */
  structure?: Maybe<GymStructure>;
  type?: Maybe<GymType>;
  users?: Maybe<Array<User>>;
};

export type GymCondition = {
  gymTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type GymInput = {
  id: Scalars['Int']['input'];
};

export type GymProgressivePlanInstances = {
  __typename?: 'GymProgressivePlanInstances';
  planInstances: Array<ProgressivePlanInstance>;
  workouts: Array<ProgressivePlanScheduleWorkout>;
};

export enum GymStructure {
  CHAIN = 'CHAIN',
  ENTERPRISE = 'ENTERPRISE',
  HPC = 'HPC',
  HPZ = 'HPZ',
  INDEPENDENT = 'INDEPENDENT'
}

export type GymStructureInput = {
  id: Scalars['ID']['input'];
};

export type GymStructureTable = {
  __typename?: 'GymStructureTable';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GymType = {
  __typename?: 'GymType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GymTypeInput = {
  id: Scalars['Int']['input'];
};

export type Image = {
  __typename?: 'Image';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['URL']['output']>;
  uploadDetails?: Maybe<MediaUploadDetails>;
  url?: Maybe<Scalars['URL']['output']>;
};


export type ImageUploadDetailsArgs = {
  extension: ImageFileExtensions;
};

export type ImageCondition = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export enum ImageFileExtensions {
  JPEG = 'JPEG',
  JPG = 'JPG',
  PNG = 'PNG'
}

export type ImageInput = {
  id: Scalars['Int']['input'];
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
  translationAutomation: LanguageTranslationAutomation;
};

export type LanguageInput = {
  code: Scalars['String']['input'];
};

export type LanguageTranslationAutomation = {
  __typename?: 'LanguageTranslationAutomation';
  resources: Scalars['Boolean']['output'];
};

export type Lesson = {
  __typename?: 'Lesson';
  apiOnly: Scalars['Boolean']['output'];
  challenges?: Maybe<Array<Challenge>>;
  classType: ClassType;
  collectionOnly: Scalars['Boolean']['output'];
  collections?: Maybe<Array<Collection>>;
  /**
   * @deprecated Use lessonConcept instead. This field is kept for backward compatibility only.
   * Always returns a concept (defaults to "Custom" if none assigned).
   * @deprecated Use lessonConcept instead. This field is kept for backward compatibility only.
   */
  concept: Concept;
  description: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  equipment?: Maybe<Array<Equipment>>;
  gymStructures: Array<GymStructureTable>;
  id: Scalars['LessonId']['output'];
  image?: Maybe<Image>;
  intensity: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isSaved: Scalars['Boolean']['output'];
  lessonConcept?: Maybe<Concept>;
  /** @deprecated No longer supported */
  migratedAt?: Maybe<Scalars['ISODateTime']['output']>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['ISODateTime']['output']>;
  schedules?: Maybe<Array<LessonSchedule>>;
  sections?: Maybe<Array<LessonSection>>;
  status: LessonStatus;
  tags?: Maybe<Array<Tag>>;
  /** @deprecated No longer supported */
  trainers?: Maybe<Array<User>>;
};


export type LessonSectionsArgs = {
  orderBy?: InputMaybe<LessonSectionOrderBy>;
};

export type LessonCondition = {
  apiOnly?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  concept?: InputMaybe<ConceptInput>;
  durationRange?: InputMaybe<DurationRange>;
  equipment?: InputMaybe<Array<EquipmentInput>>;
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  hasConcept?: InputMaybe<Scalars['Boolean']['input']>;
  includeCollectionOnlyLessons?: InputMaybe<Scalars['Boolean']['input']>;
  includePlanLessons?: InputMaybe<Scalars['Boolean']['input']>;
  intensity?: InputMaybe<Scalars['Int']['input']>;
  numberOfSections?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  status?: InputMaybe<Array<LessonStatus>>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type LessonGroup = {
  __typename?: 'LessonGroup';
  id: Scalars['LessonGroupId']['output'];
  lessons?: Maybe<Array<Lesson>>;
  weekInfo?: Maybe<LessonGroupWeekInfo>;
};

export type LessonGroupInput = {
  id: Scalars['LessonGroupId']['input'];
};

export type LessonGroupWeekInfo = {
  __typename?: 'LessonGroupWeekInfo';
  from: Scalars['ISODateTime']['output'];
  number: Scalars['Int']['output'];
  to: Scalars['ISODateTime']['output'];
};

export type LessonGroupWeekInfoInput = {
  from: Scalars['ISODateTime']['input'];
  number: Scalars['Int']['input'];
  to: Scalars['ISODateTime']['input'];
};

export type LessonInput = {
  id: Scalars['LessonId']['input'];
};

export type LessonSchedule = {
  __typename?: 'LessonSchedule';
  id: Scalars['LessonScheduleId']['output'];
  lesson?: Maybe<Lesson>;
  scheduledAt: Scalars['ISODateTime']['output'];
};

export type LessonScheduleCondition = {
  dateRange?: InputMaybe<DateRange>;
  scheduledAt?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type LessonScheduleInput = {
  id: Scalars['Int']['input'];
};

export type LessonSection = {
  __typename?: 'LessonSection';
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['Float']['output'];
  format: LessonSectionFormat;
  id: Scalars['LessonSectionId']['output'];
  isMain: Scalars['Boolean']['output'];
  isRotational: Scalars['Boolean']['output'];
  lesson?: Maybe<Lesson>;
  lessonSectionTemplate?: Maybe<LessonSectionTemplate>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use rounds instead */
  repeatTimes?: Maybe<Scalars['Int']['output']>;
  restTime?: Maybe<Scalars['Int']['output']>;
  rounds: Scalars['Int']['output'];
  sectionExerciseGroups?: Maybe<Array<SectionExerciseGroup>>;
  video?: Maybe<Video>;
  workTime?: Maybe<Scalars['Int']['output']>;
};


export type LessonSectionSectionExerciseGroupsArgs = {
  orderBy?: InputMaybe<SectionExerciseGroupOrderBy>;
};

export enum LessonSectionFormat {
  AMRAP = 'AMRAP',
  CHIPPER = 'CHIPPER',
  COOLDOWN = 'COOLDOWN',
  COUPLET = 'COUPLET',
  DOUBLE_TABATA = 'DOUBLE_TABATA',
  INTERVALS = 'INTERVALS',
  INTRO = 'INTRO',
  I_GO_YOU_GO = 'I_GO_YOU_GO',
  PARTNER_CHIPPER = 'PARTNER_CHIPPER',
  PARTNER_WORKOUT = 'PARTNER_WORKOUT',
  TABATA = 'TABATA',
  TO2M = 'TO2M',
  TO3M = 'TO3M',
  TOTM = 'TOTM',
  TRIPLET = 'TRIPLET'
}

export type LessonSectionInput = {
  id: Scalars['LessonSectionId']['input'];
};

export enum LessonSectionOrderBy {
  CREATED_AT = 'CREATED_AT',
  DISPLAY_ORDER = 'DISPLAY_ORDER'
}

export type LessonSectionTemplate = {
  __typename?: 'LessonSectionTemplate';
  description?: Maybe<Scalars['String']['output']>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  format: LessonSectionFormat;
  hideDescriptionField: Scalars['Boolean']['output'];
  hideTitleField: Scalars['Boolean']['output'];
  hideWorkRestField: Scalars['Boolean']['output'];
  id: Scalars['LessonSectionTemplateId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  restTime?: Maybe<Scalars['Int']['output']>;
  rounds?: Maybe<Scalars['Int']['output']>;
  sectionExerciseGroupTemplates?: Maybe<Array<SectionExerciseGroupTemplate>>;
  workTime?: Maybe<Scalars['Int']['output']>;
};


export type LessonSectionTemplateSectionExerciseGroupTemplatesArgs = {
  orderBy?: InputMaybe<SectionExerciseGroupOrderBy>;
};

export type LessonSectionTemplateInput = {
  id: Scalars['LessonSectionTemplateId']['input'];
};

export enum LessonStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  SCHEDULED = 'SCHEDULED',
  TESTING = 'TESTING'
}

export type LessonWithDisplayOrder = {
  __typename?: 'LessonWithDisplayOrder';
  displayOrder: Scalars['Int']['output'];
  lesson?: Maybe<Lesson>;
};

export type Link = {
  __typename?: 'Link';
  id: Scalars['LinkId']['output'];
  url: Scalars['URL']['output'];
};

export type LinkInput = {
  id: Scalars['LinkId']['input'];
};

export type MediaUploadDetails = {
  __typename?: 'MediaUploadDetails';
  keyName: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  assignUserToGym: User;
  cancelProgressivePlan?: Maybe<ProgressivePlanInstance>;
  completeLessonById: Lesson;
  createBanner: Banner;
  createChallenge: Challenge;
  createCollection: Collection;
  createCollectionList: CollectionList;
  createConcept: Concept;
  createDocument: Document;
  createEquipment: Equipment;
  createExercise: Exercise;
  createGym: Gym;
  createGymStructure: GymStructureTable;
  createGymType: GymType;
  createImage: Image;
  createLanguage: Language;
  createLesson: Lesson;
  createLessonGroup: LessonGroup;
  createLessonSchedule: LessonSchedule;
  createLessonSection: LessonSection;
  createLessonSectionTemplate: LessonSectionTemplate;
  createLink: Link;
  createPlan: Plan;
  createPlanSection: PlanSection;
  createProgressivePlan: ProgressivePlan;
  createProgressivePlanBlock: ProgressivePlanBlock;
  createProgressivePlanWeek: ProgressivePlanWeek;
  createProgressivePlanWorkout: ProgressivePlanWorkout;
  createResource: Resource;
  createResourceList: ResourceList;
  createResourceSection: ResourceSection;
  createSectionExercise: SectionExercise;
  createSectionExerciseGroup: SectionExerciseGroup;
  createSectionExerciseGroupTemplate: SectionExerciseGroupTemplate;
  createSectionExerciseTemplate: SectionExerciseTemplate;
  createSubtitle: Subtitle;
  createSubtitleGenerationJob: SubtitleGenerationJob;
  createTag: Tag;
  createUser: User;
  createVideo: Video;
  deleteBannerById: Scalars['BannerId']['output'];
  deleteChallengeById: Scalars['ChallengeId']['output'];
  deleteCollectionById: Scalars['CollectionId']['output'];
  deleteCollectionListById: Scalars['CollectionListId']['output'];
  deleteDocumentById: Scalars['DocumentId']['output'];
  deleteGymStructureById: Scalars['ID']['output'];
  deleteImageById: Scalars['Int']['output'];
  deleteLessonById: Scalars['LessonId']['output'];
  deleteLessonGroupById: Scalars['LessonGroupId']['output'];
  deleteLessonScheduleById: Scalars['LessonScheduleId']['output'];
  deleteLessonSectionById: Scalars['LessonSectionId']['output'];
  deleteLessonSectionTemplateById: Scalars['LessonSectionTemplateId']['output'];
  deleteLinkById: Scalars['LinkId']['output'];
  deletePlanById: Scalars['PlanId']['output'];
  deletePlanSectionById: Scalars['String']['output'];
  deleteProgressivePlanBlockById: Scalars['ProgressivePlanBlockId']['output'];
  deleteProgressivePlanWeekById: Scalars['ProgressivePlanWeekId']['output'];
  deleteProgressivePlanWorkoutById: Scalars['ProgressivePlanWorkoutId']['output'];
  deleteResourceById: Scalars['ResourceId']['output'];
  deleteResourceListById: Scalars['ResourceListId']['output'];
  deleteResourceSectionById: Scalars['ResourceSectionId']['output'];
  deleteSectionExerciseById: Scalars['SectionExerciseId']['output'];
  deleteSectionExerciseGroupById: Scalars['SectionExerciseGroupId']['output'];
  deleteSectionExerciseGroupTemplateById: Scalars['SectionExerciseGroupTemplateId']['output'];
  deleteSectionExerciseTemplateById: Scalars['SectionExerciseTemplateId']['output'];
  deleteSubtitleById: Scalars['SubtitleId']['output'];
  deleteTagById: Scalars['TagId']['output'];
  deleteUserById: Scalars['Int']['output'];
  deleteVideoById: Scalars['Int']['output'];
  duplicateLessonsByIds: Array<Lesson>;
  duplicatePlanById: Plan;
  patchBannerById: Banner;
  patchChallengeById: Challenge;
  patchCollectionById: Collection;
  patchCollectionListById: CollectionList;
  patchConceptById: Concept;
  patchDocumentById: Document;
  patchEquipmentById: Equipment;
  patchExerciseById: Exercise;
  patchGymById: Gym;
  patchGymStructureById: GymStructureTable;
  patchGymTypeById: GymType;
  patchImageById: Image;
  patchLanguageByCode: Language;
  patchLessonById: Lesson;
  patchLessonGroupById: LessonGroup;
  patchLessonScheduleById: LessonSchedule;
  patchLessonSectionById: LessonSection;
  patchLessonSectionTemplateById: LessonSectionTemplate;
  patchLinkById: Link;
  patchPlanById: Plan;
  patchPlanSectionById: PlanSection;
  patchProgressivePlanBlockById: ProgressivePlanBlock;
  patchProgressivePlanById: ProgressivePlan;
  patchProgressivePlanWeekById: ProgressivePlanWeek;
  patchProgressivePlanWorkoutById: ProgressivePlanWorkout;
  patchResourceById: Resource;
  patchResourceListById: ResourceList;
  patchResourceSectionById: ResourceSection;
  patchSectionExerciseById: SectionExercise;
  patchSectionExerciseGroupById: SectionExerciseGroup;
  patchSectionExerciseGroupTemplateById: SectionExerciseGroupTemplate;
  patchSectionExerciseTemplateById: SectionExerciseTemplate;
  patchSubtitleById: Subtitle;
  patchTagById: Tag;
  patchUserById: User;
  patchVideoById: Video;
  saveLessonById: Lesson;
  startProgressivePlan: ProgressivePlanInstance;
  uncompleteLessonById: Lesson;
  unsaveLessonById: Lesson;
};


export type MutationAssignUserToGymArgs = {
  input: AssignUserToGymInput;
};


export type MutationCancelProgressivePlanArgs = {
  input: CancelProgressivePlanInput;
};


export type MutationCompleteLessonByIdArgs = {
  id: Scalars['LessonId']['input'];
  input: CompleteLessonByIdInput;
};


export type MutationCreateBannerArgs = {
  input: CreateBannerInput;
};


export type MutationCreateChallengeArgs = {
  input: CreateChallengeInput;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateCollectionListArgs = {
  input: CreateCollectionListInput;
};


export type MutationCreateConceptArgs = {
  input: CreateConceptInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateEquipmentArgs = {
  input: CreateEquipmentInput;
};


export type MutationCreateExerciseArgs = {
  input: CreateExerciseInput;
};


export type MutationCreateGymArgs = {
  input: CreateGymInput;
};


export type MutationCreateGymStructureArgs = {
  input: CreateGymStructureInput;
};


export type MutationCreateGymTypeArgs = {
  input: CreateGymTypeInput;
};


export type MutationCreateImageArgs = {
  input: CreateImageInput;
};


export type MutationCreateLanguageArgs = {
  input: CreateLanguageInput;
};


export type MutationCreateLessonArgs = {
  input: CreateLessonInput;
};


export type MutationCreateLessonGroupArgs = {
  input: CreateLessonGroupInput;
};


export type MutationCreateLessonScheduleArgs = {
  input: CreateLessonScheduleInput;
};


export type MutationCreateLessonSectionArgs = {
  input: CreateLessonSectionInput;
};


export type MutationCreateLessonSectionTemplateArgs = {
  input: CreateLessonSectionTemplateInput;
};


export type MutationCreateLinkArgs = {
  input: CreateLinkInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreatePlanSectionArgs = {
  input: CreatePlanSectionInput;
};


export type MutationCreateProgressivePlanArgs = {
  input: CreateProgressivePlanInput;
};


export type MutationCreateProgressivePlanBlockArgs = {
  input: CreateProgressivePlanBlockInput;
};


export type MutationCreateProgressivePlanWeekArgs = {
  input: CreateProgressivePlanWeekInput;
};


export type MutationCreateProgressivePlanWorkoutArgs = {
  input: CreateProgressivePlanWorkoutInput;
};


export type MutationCreateResourceArgs = {
  input: CreateResourceInput;
};


export type MutationCreateResourceListArgs = {
  input: CreateResourceListInput;
};


export type MutationCreateResourceSectionArgs = {
  input: CreateResourceSectionInput;
};


export type MutationCreateSectionExerciseArgs = {
  input: CreateSectionExerciseInput;
};


export type MutationCreateSectionExerciseGroupArgs = {
  input: CreateSectionExerciseGroupInput;
};


export type MutationCreateSectionExerciseGroupTemplateArgs = {
  input: CreateSectionExerciseGroupTemplateInput;
};


export type MutationCreateSectionExerciseTemplateArgs = {
  input: CreateSectionExerciseTemplateInput;
};


export type MutationCreateSubtitleArgs = {
  input: CreateSubtitleInput;
};


export type MutationCreateSubtitleGenerationJobArgs = {
  input: CreateSubtitleGenerationJobInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVideoArgs = {
  input: CreateVideoInput;
};


export type MutationDeleteBannerByIdArgs = {
  id: Scalars['BannerId']['input'];
};


export type MutationDeleteChallengeByIdArgs = {
  id: Scalars['ChallengeId']['input'];
};


export type MutationDeleteCollectionByIdArgs = {
  id: Scalars['CollectionId']['input'];
};


export type MutationDeleteCollectionListByIdArgs = {
  id: Scalars['CollectionListId']['input'];
};


export type MutationDeleteDocumentByIdArgs = {
  id: Scalars['DocumentId']['input'];
};


export type MutationDeleteGymStructureByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteImageByIdArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLessonByIdArgs = {
  id: Scalars['LessonId']['input'];
};


export type MutationDeleteLessonGroupByIdArgs = {
  id: Scalars['LessonGroupId']['input'];
};


export type MutationDeleteLessonScheduleByIdArgs = {
  id: Scalars['LessonScheduleId']['input'];
};


export type MutationDeleteLessonSectionByIdArgs = {
  id: Scalars['LessonSectionId']['input'];
};


export type MutationDeleteLessonSectionTemplateByIdArgs = {
  id: Scalars['LessonSectionTemplateId']['input'];
};


export type MutationDeleteLinkByIdArgs = {
  id: Scalars['LinkId']['input'];
};


export type MutationDeletePlanByIdArgs = {
  id: Scalars['PlanId']['input'];
};


export type MutationDeletePlanSectionByIdArgs = {
  id: Scalars['PlanSectionId']['input'];
};


export type MutationDeleteProgressivePlanBlockByIdArgs = {
  id: Scalars['ProgressivePlanBlockId']['input'];
};


export type MutationDeleteProgressivePlanWeekByIdArgs = {
  id: Scalars['ProgressivePlanWeekId']['input'];
};


export type MutationDeleteProgressivePlanWorkoutByIdArgs = {
  id: Scalars['ProgressivePlanWorkoutId']['input'];
};


export type MutationDeleteResourceByIdArgs = {
  id: Scalars['ResourceId']['input'];
};


export type MutationDeleteResourceListByIdArgs = {
  id: Scalars['ResourceListId']['input'];
};


export type MutationDeleteResourceSectionByIdArgs = {
  id: Scalars['ResourceSectionId']['input'];
};


export type MutationDeleteSectionExerciseByIdArgs = {
  id: Scalars['SectionExerciseId']['input'];
};


export type MutationDeleteSectionExerciseGroupByIdArgs = {
  id: Scalars['SectionExerciseGroupId']['input'];
};


export type MutationDeleteSectionExerciseGroupTemplateByIdArgs = {
  id: Scalars['SectionExerciseGroupTemplateId']['input'];
};


export type MutationDeleteSectionExerciseTemplateByIdArgs = {
  id: Scalars['SectionExerciseTemplateId']['input'];
};


export type MutationDeleteSubtitleByIdArgs = {
  id: Scalars['SubtitleId']['input'];
};


export type MutationDeleteTagByIdArgs = {
  id: Scalars['TagId']['input'];
};


export type MutationDeleteUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteVideoByIdArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDuplicateLessonsByIdsArgs = {
  ids: Array<Scalars['LessonId']['input']>;
};


export type MutationDuplicatePlanByIdArgs = {
  id: Scalars['PlanId']['input'];
};


export type MutationPatchBannerByIdArgs = {
  id: Scalars['BannerId']['input'];
  input: PatchBannerInput;
};


export type MutationPatchChallengeByIdArgs = {
  id: Scalars['ChallengeId']['input'];
  input: PatchChallengeByIdInput;
};


export type MutationPatchCollectionByIdArgs = {
  id: Scalars['CollectionId']['input'];
  input: PatchCollectionByIdInput;
};


export type MutationPatchCollectionListByIdArgs = {
  id: Scalars['CollectionListId']['input'];
  input: PatchCollectionListByIdInput;
};


export type MutationPatchConceptByIdArgs = {
  id: Scalars['ConceptId']['input'];
  input: PatchConceptByIdInput;
};


export type MutationPatchDocumentByIdArgs = {
  id: Scalars['DocumentId']['input'];
  input: PatchDocumentByIdInput;
};


export type MutationPatchEquipmentByIdArgs = {
  id: Scalars['Int']['input'];
  input: PatchEquipmentByIdInput;
};


export type MutationPatchExerciseByIdArgs = {
  id: Scalars['ExerciseId']['input'];
  input: PatchExerciseByIdInput;
};


export type MutationPatchGymByIdArgs = {
  id: Scalars['Int']['input'];
  input: PatchGymByIdInput;
};


export type MutationPatchGymStructureByIdArgs = {
  id: Scalars['ID']['input'];
  input: PatchGymStructureByIdInput;
};


export type MutationPatchGymTypeByIdArgs = {
  id: Scalars['Int']['input'];
  input: PatchGymTypeByIdInput;
};


export type MutationPatchImageByIdArgs = {
  id: Scalars['Int']['input'];
  input: PatchImageByIdInput;
};


export type MutationPatchLanguageByCodeArgs = {
  code: Scalars['String']['input'];
  input: PatchLanguageByCodeInput;
};


export type MutationPatchLessonByIdArgs = {
  id: Scalars['LessonId']['input'];
  input: PatchLessonByIdInput;
};


export type MutationPatchLessonGroupByIdArgs = {
  id: Scalars['LessonGroupId']['input'];
  input: PatchLessonGroupByIdInput;
};


export type MutationPatchLessonScheduleByIdArgs = {
  id: Scalars['LessonScheduleId']['input'];
  input: PatchLessonScheduleByIdInput;
};


export type MutationPatchLessonSectionByIdArgs = {
  id: Scalars['LessonSectionId']['input'];
  input: PatchLessonSectionByIdInput;
};


export type MutationPatchLessonSectionTemplateByIdArgs = {
  id: Scalars['LessonSectionTemplateId']['input'];
  input: PatchLessonSectionTemplateByIdInput;
};


export type MutationPatchLinkByIdArgs = {
  id: Scalars['LinkId']['input'];
  input: PatchLinkByIdInput;
};


export type MutationPatchPlanByIdArgs = {
  id: Scalars['PlanId']['input'];
  input: PatchPlanByIdInput;
};


export type MutationPatchPlanSectionByIdArgs = {
  id: Scalars['PlanSectionId']['input'];
  input: PatchPlanSectionByIdInput;
};


export type MutationPatchProgressivePlanBlockByIdArgs = {
  id: Scalars['ProgressivePlanBlockId']['input'];
  input: PatchProgressivePlanBlockInput;
};


export type MutationPatchProgressivePlanByIdArgs = {
  id: Scalars['ProgressivePlanId']['input'];
  input: PatchProgressivePlanInput;
};


export type MutationPatchProgressivePlanWeekByIdArgs = {
  id: Scalars['ProgressivePlanWeekId']['input'];
  input: PatchProgressivePlanWeekInput;
};


export type MutationPatchProgressivePlanWorkoutByIdArgs = {
  id: Scalars['ProgressivePlanWorkoutId']['input'];
  input: PatchProgressivePlanWorkoutInput;
};


export type MutationPatchResourceByIdArgs = {
  id: Scalars['ResourceId']['input'];
  input: PatchResourceByIdInput;
};


export type MutationPatchResourceListByIdArgs = {
  id: Scalars['ResourceListId']['input'];
  input: PatchResourceListByIdInput;
};


export type MutationPatchResourceSectionByIdArgs = {
  id: Scalars['ResourceSectionId']['input'];
  input: PatchResourceSectionByIdInput;
};


export type MutationPatchSectionExerciseByIdArgs = {
  id: Scalars['SectionExerciseId']['input'];
  input: PatchSectionExerciseByIdInput;
};


export type MutationPatchSectionExerciseGroupByIdArgs = {
  id: Scalars['SectionExerciseGroupId']['input'];
  input: PatchSectionExerciseGroupByIdInput;
};


export type MutationPatchSectionExerciseGroupTemplateByIdArgs = {
  id: Scalars['SectionExerciseGroupTemplateId']['input'];
  input: PatchSectionExerciseGroupTemplateByIdInput;
};


export type MutationPatchSectionExerciseTemplateByIdArgs = {
  id: Scalars['SectionExerciseTemplateId']['input'];
  input: PatchSectionExerciseTemplateByIdInput;
};


export type MutationPatchSubtitleByIdArgs = {
  id: Scalars['SubtitleId']['input'];
  input: PatchSubtitleByIdInput;
};


export type MutationPatchTagByIdArgs = {
  id: Scalars['TagId']['input'];
  input: PatchTagByIdInput;
};


export type MutationPatchUserByIdArgs = {
  id: Scalars['Int']['input'];
  input: PatchUserByIdInput;
};


export type MutationPatchVideoByIdArgs = {
  id: Scalars['Int']['input'];
  input: PatchVideoByIdInput;
};


export type MutationSaveLessonByIdArgs = {
  id: Scalars['LessonId']['input'];
  input: SaveLessonByIdInput;
};


export type MutationStartProgressivePlanArgs = {
  input: StartProgressivePlanInput;
};


export type MutationUncompleteLessonByIdArgs = {
  id: Scalars['LessonId']['input'];
  input: UncompleteLessonByIdInput;
};


export type MutationUnsaveLessonByIdArgs = {
  id: Scalars['LessonId']['input'];
  input: UnsaveLessonByIdInput;
};

export type NotesToHtmlResponse = {
  __typename?: 'NotesToHTMLResponse';
  notes: Scalars['String']['output'];
};

export type PaginatedChallenges = PaginatedResponse & {
  __typename?: 'PaginatedChallenges';
  nodes?: Maybe<Array<Challenge>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCollectionLists = PaginatedResponse & {
  __typename?: 'PaginatedCollectionLists';
  nodes?: Maybe<Array<CollectionList>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedCollections = PaginatedResponse & {
  __typename?: 'PaginatedCollections';
  nodes?: Maybe<Array<Collection>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedDocument = PaginatedResponse & {
  __typename?: 'PaginatedDocument';
  nodes?: Maybe<Array<Document>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedExercises = PaginatedResponse & {
  __typename?: 'PaginatedExercises';
  nodes?: Maybe<Array<Exercise>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedImages = PaginatedResponse & {
  __typename?: 'PaginatedImages';
  nodes?: Maybe<Array<Image>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedLessonGroups = PaginatedResponse & {
  __typename?: 'PaginatedLessonGroups';
  nodes?: Maybe<Array<LessonGroup>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedLessons = PaginatedResponse & {
  __typename?: 'PaginatedLessons';
  nodes?: Maybe<Array<Lesson>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPlans = PaginatedResponse & {
  __typename?: 'PaginatedPlans';
  nodes?: Maybe<Array<Plan>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedProgressivePlans = PaginatedResponse & {
  __typename?: 'PaginatedProgressivePlans';
  nodes?: Maybe<Array<ProgressivePlan>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResponse = {
  totalCount: Scalars['Int']['output'];
};

export type PaginatedVideos = PaginatedResponse & {
  __typename?: 'PaginatedVideos';
  nodes?: Maybe<Array<Video>>;
  totalCount: Scalars['Int']['output'];
};

export type PatchBannerInput = {
  activeFrom?: InputMaybe<Scalars['ISODateTime']['input']>;
  activeTo?: InputMaybe<Scalars['ISODateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gymStructures?: InputMaybe<Array<GymStructure>>;
  image?: InputMaybe<ImageInput>;
  link?: InputMaybe<Scalars['String']['input']>;
  mobileImage?: InputMaybe<ImageInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PatchChallengeByIdInput = {
  challengeImage?: InputMaybe<ImageInput>;
  challengeType?: InputMaybe<ChallengeType>;
  ctaImage?: InputMaybe<ImageInput>;
  lesson?: InputMaybe<LessonInput>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resourcePage?: InputMaybe<ResourceInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PatchCollectionByIdInput = {
  bannerImage?: InputMaybe<ImageInput>;
  collectionList?: InputMaybe<CollectionListInput>;
  condition?: InputMaybe<CollectionCondition>;
  ctaImage?: InputMaybe<ImageInput>;
  lessons?: InputMaybe<Array<LessonInput>>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<ResourceInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PatchCollectionListByIdInput = {
  collections?: InputMaybe<Array<CollectionWithDisplayOrderInput>>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PatchConceptByIdInput = {
  hiddenConcept?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PatchDocumentByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  keyName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type PatchEquipmentByIdInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PatchExerciseByIdInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alternativeExercises?: InputMaybe<Array<ExerciseInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<EquipmentInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<VideoInput>;
};

export type PatchGymByIdInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<CountryCode>;
  equipment?: InputMaybe<Array<EquipmentInput>>;
  gymStructure?: InputMaybe<GymStructureInput>;
  gymType?: InputMaybe<GymTypeInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<LanguageInput>;
  /** @deprecated Use gymStructure instead. This field is kept for backward compatibility only. */
  structure?: InputMaybe<GymStructure>;
};

export type PatchGymStructureByIdInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PatchGymTypeByIdInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PatchImageByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  keyName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type PatchLanguageByCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ImageInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  resourceTranslationAutomated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatchLessonByIdInput = {
  apiOnly?: InputMaybe<Scalars['Boolean']['input']>;
  classType?: InputMaybe<ClassType>;
  collectionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  concept?: InputMaybe<ConceptInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Array<EquipmentInput>>;
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  image?: InputMaybe<ImageInput>;
  intensity?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  status?: InputMaybe<LessonStatus>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type PatchLessonGroupByIdInput = {
  lessons?: InputMaybe<Array<LessonInput>>;
  weekInfo?: InputMaybe<PatchLessonGroupWeekInfoInput>;
};

export type PatchLessonGroupWeekInfoInput = {
  from?: InputMaybe<Scalars['ISODateTime']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type PatchLessonScheduleByIdInput = {
  lesson?: InputMaybe<LessonInput>;
  scheduledAt?: InputMaybe<Scalars['ISODateTime']['input']>;
};

export type PatchLessonSectionByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<LessonSectionFormat>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  isRotational?: InputMaybe<Scalars['Boolean']['input']>;
  lessonSectionTemplate?: InputMaybe<LessonSectionTemplateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  restTime?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  video?: InputMaybe<VideoInput>;
  workTime?: InputMaybe<Scalars['Int']['input']>;
};

export type PatchLessonSectionTemplateByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayDescription?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<LessonSectionFormat>;
  hideDescriptionField?: InputMaybe<Scalars['Boolean']['input']>;
  hideTitleField?: InputMaybe<Scalars['Boolean']['input']>;
  hideWorkRestField?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  restTime?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  workTime?: InputMaybe<Scalars['Int']['input']>;
};

export type PatchLinkByIdInput = {
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type PatchPlanByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<ImageInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PatchPlanSectionByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  lessonIds?: InputMaybe<Array<Scalars['LessonId']['input']>>;
  planId?: InputMaybe<Scalars['PlanId']['input']>;
  sectionDuration?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PatchProgressivePlanBlockInput = {
  desktopImage?: InputMaybe<ImageInput>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  introText?: InputMaybe<Scalars['String']['input']>;
  introVideo?: InputMaybe<VideoInput>;
  mobileImage?: InputMaybe<ImageInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  weeks?: InputMaybe<Array<CreateProgressivePlanWeekInput>>;
};

export type PatchProgressivePlanInput = {
  bannerImage?: InputMaybe<ImageInput>;
  ctaImage?: InputMaybe<ImageInput>;
  isPromoted?: InputMaybe<Scalars['Boolean']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overviewVideo?: InputMaybe<VideoInput>;
  progressivePlanBlocks?: InputMaybe<Array<CreateProgressivePlanBlockInput>>;
  resource?: InputMaybe<ResourceInput>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startAvailableAt?: InputMaybe<Scalars['ISODateTime']['input']>;
  status?: InputMaybe<ProgressivePlanStatus>;
};

export type PatchProgressivePlanWeekInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
  workouts?: InputMaybe<Array<CreateProgressivePlanWorkoutInput>>;
};

export type PatchProgressivePlanWorkoutInput = {
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  lesson?: InputMaybe<LessonInput>;
};

export type PatchResourceByIdInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  image?: InputMaybe<ImageInput>;
  status?: InputMaybe<ResourceStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PatchResourceListByIdInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  image?: InputMaybe<ImageInput>;
  resourceLists?: InputMaybe<Array<ResourceListInput>>;
  resources?: InputMaybe<Array<ResourceInput>>;
  status?: InputMaybe<ResourceListStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PatchResourceSectionByIdInput = {
  componentAlignment?: InputMaybe<ComponentAlignment>;
  content?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  documents?: InputMaybe<Array<DocumentInput>>;
  images?: InputMaybe<Array<ImageInput>>;
  links?: InputMaybe<Array<LinkInput>>;
  resource?: InputMaybe<ResourceInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<VideoInput>>;
};

export type PatchSectionExerciseByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  exercise?: InputMaybe<ExerciseInput>;
  group?: InputMaybe<SectionExerciseGroupInput>;
  maxDistance?: InputMaybe<Scalars['Float']['input']>;
  maxRepetitions?: InputMaybe<Scalars['Float']['input']>;
  maxWeight?: InputMaybe<Scalars['Float']['input']>;
  minDistance?: InputMaybe<Scalars['Float']['input']>;
  minRepetitions?: InputMaybe<Scalars['Float']['input']>;
  minWeight?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rpe?: InputMaybe<Scalars['Int']['input']>;
  singleDistance?: InputMaybe<Scalars['Float']['input']>;
  singleRepetitions?: InputMaybe<Scalars['Float']['input']>;
  singleWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PatchSectionExerciseGroupByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentSectionExerciseGroup?: InputMaybe<SectionExerciseGroupInput>;
  repeatTimes?: InputMaybe<Scalars['Int']['input']>;
  sectionExerciseGroupTemplate?: InputMaybe<SectionExerciseGroupTemplateInput>;
  sectionExerciseGroups?: InputMaybe<Array<SectionExerciseGroupWithDisplayOrderInput>>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatchSectionExerciseGroupTemplateByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayDescription?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<LessonSectionFormat>;
  hideDescriptionField?: InputMaybe<Scalars['Boolean']['input']>;
  hideTitleField?: InputMaybe<Scalars['Boolean']['input']>;
  lessonSectionTemplate?: InputMaybe<LessonSectionTemplateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentSectionExerciseGroupTemplate?: InputMaybe<SectionExerciseGroupTemplateInput>;
  sectionExerciseGroupTemplates?: InputMaybe<Array<SectionExerciseGroupTemplateInput>>;
};

export type PatchSectionExerciseTemplateByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exercise?: InputMaybe<ExerciseInput>;
  sectionExerciseGroupTemplate?: InputMaybe<SectionExerciseGroupTemplateInput>;
};

export type PatchSubtitleByIdInput = {
  keyName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageInput>;
  video?: InputMaybe<VideoInput>;
};

export type PatchTagByIdInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PatchUserByIdInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<LanguageInput>;
  profileImage?: InputMaybe<ImageInput>;
  type?: InputMaybe<UserType>;
  userRole?: InputMaybe<UserRole>;
};

export type PatchVideoByIdInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  keyName?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<ImageInput>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type Plan = {
  __typename?: 'Plan';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['PlanId']['output'];
  image?: Maybe<Image>;
  sections?: Maybe<Array<PlanSection>>;
  title: Scalars['String']['output'];
};

export type PlanCondition = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PlanInput = {
  id: Scalars['PlanId']['input'];
};

export type PlanSection = {
  __typename?: 'PlanSection';
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['PlanSectionId']['output'];
  lessons?: Maybe<Array<LessonWithDisplayOrder>>;
  plan: Plan;
  /** Duration of the section in days */
  sectionDuration: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ProgressivePlan = {
  __typename?: 'ProgressivePlan';
  bannerImage?: Maybe<Image>;
  blocks?: Maybe<Array<ProgressivePlanBlock>>;
  ctaImage?: Maybe<Image>;
  id: Scalars['ProgressivePlanId']['output'];
  isPromoted: Scalars['Boolean']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overviewVideo?: Maybe<Video>;
  resource?: Maybe<Resource>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  startAvailableAt?: Maybe<Scalars['ISODateTime']['output']>;
  status: ProgressivePlanStatus;
};

export type ProgressivePlanBlock = {
  __typename?: 'ProgressivePlanBlock';
  desktopImage?: Maybe<Image>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ProgressivePlanBlockId']['output'];
  introText?: Maybe<Scalars['String']['output']>;
  introVideo?: Maybe<Video>;
  mobileImage?: Maybe<Image>;
  name: Scalars['String']['output'];
  progressivePlan: ProgressivePlan;
  weeks?: Maybe<Array<ProgressivePlanWeek>>;
};

export type ProgressivePlanBlockInput = {
  id: Scalars['ProgressivePlanBlockId']['input'];
};

export type ProgressivePlanCondition = {
  isPromoted?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ProgressivePlanStatus>>;
};

export type ProgressivePlanInput = {
  id: Scalars['ProgressivePlanId']['input'];
};

export type ProgressivePlanInstance = {
  __typename?: 'ProgressivePlanInstance';
  cancelledAt?: Maybe<Scalars['ISODateTime']['output']>;
  currentBlock?: Maybe<ProgressivePlanBlock>;
  currentWeek?: Maybe<ProgressivePlanWeek>;
  gym: Gym;
  id: Scalars['ProgressivePlanInstanceId']['output'];
  progressivePlan: ProgressivePlan;
  startedAt: Scalars['ISODateTime']['output'];
  status: ProgressivePlanInstanceStatus;
  timezone: Scalars['String']['output'];
  todaysWorkout?: Maybe<ProgressivePlanScheduleWorkout>;
  upcomingWorkouts: Array<ProgressivePlanScheduleWorkout>;
};


export type ProgressivePlanInstanceUpcomingWorkoutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgressivePlanInstanceInput = {
  id: Scalars['ProgressivePlanInstanceId']['input'];
};

export enum ProgressivePlanInstanceStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED'
}

export type ProgressivePlanScheduleWorkout = {
  __typename?: 'ProgressivePlanScheduleWorkout';
  id: Scalars['ProgressivePlanScheduleWorkoutId']['output'];
  progressivePlanInstance: ProgressivePlanInstance;
  progressivePlanWorkout: ProgressivePlanWorkout;
  scheduledAt: Scalars['ISODateTime']['output'];
};

export type ProgressivePlanScheduleWorkoutInput = {
  id: Scalars['ProgressivePlanScheduleWorkoutId']['input'];
};

export enum ProgressivePlanStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  TESTING = 'TESTING'
}

export type ProgressivePlanWeek = {
  __typename?: 'ProgressivePlanWeek';
  id: Scalars['ProgressivePlanWeekId']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  progressivePlanBlock: ProgressivePlanBlock;
  shortDescription?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weekNumber: Scalars['Int']['output'];
  workouts?: Maybe<Array<ProgressivePlanWorkout>>;
};

export type ProgressivePlanWeekInput = {
  id: Scalars['ProgressivePlanWeekId']['input'];
};

export type ProgressivePlanWorkout = {
  __typename?: 'ProgressivePlanWorkout';
  dayOfWeek: Scalars['Int']['output'];
  id: Scalars['ProgressivePlanWorkoutId']['output'];
  lesson?: Maybe<Lesson>;
  progressivePlanWeek: ProgressivePlanWeek;
};

export type ProgressivePlanWorkoutInput = {
  id: Scalars['ProgressivePlanWorkoutId']['input'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  allBanners?: Maybe<Array<Banner>>;
  allChallenges?: Maybe<PaginatedChallenges>;
  allCollectionLists?: Maybe<PaginatedCollectionLists>;
  allCollections?: Maybe<PaginatedCollections>;
  allConcepts?: Maybe<Array<Concept>>;
  allDocuments?: Maybe<PaginatedDocument>;
  allEquipment?: Maybe<Array<Equipment>>;
  allExercises?: Maybe<PaginatedExercises>;
  allGymStructures?: Maybe<Array<GymStructureTable>>;
  allGymTypes?: Maybe<Array<GymType>>;
  allGyms?: Maybe<Array<Gym>>;
  allImages?: Maybe<PaginatedImages>;
  allLanguages?: Maybe<Array<Language>>;
  allLessonGroups?: Maybe<PaginatedLessonGroups>;
  allLessonSchedules?: Maybe<Array<LessonSchedule>>;
  allLessonSectionTemplates?: Maybe<Array<LessonSectionTemplate>>;
  allLessonSections?: Maybe<Array<LessonSection>>;
  allLessons?: Maybe<PaginatedLessons>;
  allLinks?: Maybe<Array<Link>>;
  allPlans?: Maybe<PaginatedPlans>;
  allProgressivePlanInstances?: Maybe<GymProgressivePlanInstances>;
  allProgressivePlans?: Maybe<PaginatedProgressivePlans>;
  allResourceLists?: Maybe<Array<ResourceList>>;
  allResourceSections?: Maybe<Array<ResourceSection>>;
  allResources?: Maybe<Array<Resource>>;
  allRootSectionExerciseGroupTemplates?: Maybe<Array<SectionExerciseGroupTemplate>>;
  allSectionExerciseGroupTemplates?: Maybe<Array<SectionExerciseGroupTemplate>>;
  allSectionExerciseGroups?: Maybe<Array<SectionExerciseGroup>>;
  allSectionExerciseTemplates?: Maybe<Array<SectionExerciseTemplate>>;
  allSectionExercises?: Maybe<Array<SectionExercise>>;
  allSubtitleGenerationJobs: Array<SubtitleGenerationJob>;
  allTags?: Maybe<Array<Tag>>;
  allUsers?: Maybe<Array<User>>;
  allVideos?: Maybe<PaginatedVideos>;
  bannerById?: Maybe<Banner>;
  challengeById?: Maybe<Challenge>;
  collectionById?: Maybe<Collection>;
  collectionListById?: Maybe<CollectionList>;
  conceptById?: Maybe<Concept>;
  documentById?: Maybe<Document>;
  equipmentById?: Maybe<Equipment>;
  exerciseById?: Maybe<Exercise>;
  gymById?: Maybe<Gym>;
  gymStructureById?: Maybe<GymStructureTable>;
  gymTypeById?: Maybe<GymType>;
  imageById?: Maybe<Image>;
  languageByCode?: Maybe<Language>;
  lessonById?: Maybe<Lesson>;
  lessonGroupById?: Maybe<LessonGroup>;
  lessonScheduleById?: Maybe<LessonSchedule>;
  lessonSectionById?: Maybe<LessonSection>;
  lessonSectionTemplateById?: Maybe<LessonSectionTemplate>;
  linkById?: Maybe<Link>;
  llmNotesToHTML?: Maybe<NotesToHtmlResponse>;
  llmWorkoutDescription?: Maybe<WorkoutDescription>;
  oneFiitLessons?: Maybe<PaginatedLessons>;
  planById?: Maybe<Plan>;
  progressivePlanBlockById?: Maybe<ProgressivePlanBlock>;
  progressivePlanById?: Maybe<ProgressivePlan>;
  progressivePlanInstanceById?: Maybe<ProgressivePlanInstance>;
  progressivePlanScheduleWorkoutById?: Maybe<ProgressivePlanScheduleWorkout>;
  progressivePlanWeekById?: Maybe<ProgressivePlanWeek>;
  progressivePlanWorkoutById?: Maybe<ProgressivePlanWorkout>;
  resourceById?: Maybe<Resource>;
  resourceListById?: Maybe<ResourceList>;
  resourceSectionById?: Maybe<ResourceSection>;
  sectionExerciseById?: Maybe<SectionExercise>;
  sectionExerciseGroupById?: Maybe<SectionExerciseGroup>;
  sectionExerciseGroupTemplateById?: Maybe<SectionExerciseGroupTemplate>;
  sectionExerciseTemplateById?: Maybe<SectionExerciseTemplate>;
  subtitleGenerationJobById?: Maybe<SubtitleGenerationJob>;
  subtitleGenerationJobByVideoId?: Maybe<SubtitleGenerationJob>;
  tagById?: Maybe<Tag>;
  uploadFileDetails: MediaUploadDetails;
  userById?: Maybe<User>;
  videoById?: Maybe<Video>;
};


export type QueryAllBannersArgs = {
  condition?: InputMaybe<BannerCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllChallengesArgs = {
  condition?: InputMaybe<ChallengeCondition>;
  filters?: InputMaybe<SelectAllArgs>;
  orderBy?: InputMaybe<ChallengeOrderBy>;
};


export type QueryAllCollectionListsArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllCollectionsArgs = {
  filters?: InputMaybe<SelectAllArgs>;
  orderBy?: InputMaybe<CollectionOrderBy>;
};


export type QueryAllConceptsArgs = {
  condition?: InputMaybe<ConceptCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllDocumentsArgs = {
  condition?: InputMaybe<DocumentCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllEquipmentArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllExercisesArgs = {
  condition?: InputMaybe<ExerciseCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllGymTypesArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllGymsArgs = {
  condition?: InputMaybe<GymCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllImagesArgs = {
  condition?: InputMaybe<ImageCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllLanguagesArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllLessonGroupsArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllLessonSchedulesArgs = {
  condition?: InputMaybe<LessonScheduleCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllLessonSectionTemplatesArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllLessonSectionsArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllLessonsArgs = {
  condition?: InputMaybe<LessonCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllLinksArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllPlansArgs = {
  condition?: InputMaybe<PlanCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllProgressivePlanInstancesArgs = {
  filter?: InputMaybe<AllProgressivePlanInstancesFilter>;
};


export type QueryAllProgressivePlansArgs = {
  condition?: InputMaybe<ProgressivePlanCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllResourceListsArgs = {
  condition?: InputMaybe<ResourceListCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllResourceSectionsArgs = {
  condition?: InputMaybe<ResourceSectionCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllResourcesArgs = {
  condition?: InputMaybe<ResourceCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllRootSectionExerciseGroupTemplatesArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllSectionExerciseGroupTemplatesArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllSectionExerciseGroupsArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllSectionExerciseTemplatesArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllSectionExercisesArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllTagsArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllUsersArgs = {
  condition?: InputMaybe<UserCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryAllVideosArgs = {
  condition?: InputMaybe<VideoCondition>;
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryBannerByIdArgs = {
  id: Scalars['BannerId']['input'];
};


export type QueryChallengeByIdArgs = {
  id: Scalars['ChallengeId']['input'];
};


export type QueryCollectionByIdArgs = {
  id: Scalars['CollectionId']['input'];
};


export type QueryCollectionListByIdArgs = {
  id: Scalars['CollectionListId']['input'];
};


export type QueryConceptByIdArgs = {
  id: Scalars['ConceptId']['input'];
};


export type QueryDocumentByIdArgs = {
  id: Scalars['DocumentId']['input'];
};


export type QueryEquipmentByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryExerciseByIdArgs = {
  id: Scalars['ExerciseId']['input'];
};


export type QueryGymByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGymStructureByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGymTypeByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryImageByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLanguageByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryLessonByIdArgs = {
  id: Scalars['LessonId']['input'];
};


export type QueryLessonGroupByIdArgs = {
  id: Scalars['LessonGroupId']['input'];
};


export type QueryLessonScheduleByIdArgs = {
  id: Scalars['LessonScheduleId']['input'];
};


export type QueryLessonSectionByIdArgs = {
  id: Scalars['LessonSectionId']['input'];
};


export type QueryLessonSectionTemplateByIdArgs = {
  id: Scalars['LessonSectionTemplateId']['input'];
};


export type QueryLinkByIdArgs = {
  id: Scalars['LinkId']['input'];
};


export type QueryLlmNotesToHtmlArgs = {
  text: Scalars['String']['input'];
};


export type QueryLlmWorkoutDescriptionArgs = {
  text: Scalars['String']['input'];
};


export type QueryOneFiitLessonsArgs = {
  filters?: InputMaybe<SelectAllArgs>;
};


export type QueryPlanByIdArgs = {
  id: Scalars['PlanId']['input'];
};


export type QueryProgressivePlanBlockByIdArgs = {
  id: Scalars['ProgressivePlanBlockId']['input'];
};


export type QueryProgressivePlanByIdArgs = {
  id: Scalars['ProgressivePlanId']['input'];
};


export type QueryProgressivePlanInstanceByIdArgs = {
  id: Scalars['ProgressivePlanInstanceId']['input'];
};


export type QueryProgressivePlanScheduleWorkoutByIdArgs = {
  id: Scalars['ProgressivePlanScheduleWorkoutId']['input'];
};


export type QueryProgressivePlanWeekByIdArgs = {
  id: Scalars['ProgressivePlanWeekId']['input'];
};


export type QueryProgressivePlanWorkoutByIdArgs = {
  id: Scalars['ProgressivePlanWorkoutId']['input'];
};


export type QueryResourceByIdArgs = {
  id: Scalars['ResourceId']['input'];
};


export type QueryResourceListByIdArgs = {
  id: Scalars['ResourceListId']['input'];
};


export type QueryResourceSectionByIdArgs = {
  id: Scalars['ResourceSectionId']['input'];
};


export type QuerySectionExerciseByIdArgs = {
  id: Scalars['SectionExerciseId']['input'];
};


export type QuerySectionExerciseGroupByIdArgs = {
  id: Scalars['SectionExerciseGroupId']['input'];
};


export type QuerySectionExerciseGroupTemplateByIdArgs = {
  id: Scalars['SectionExerciseGroupTemplateId']['input'];
};


export type QuerySectionExerciseTemplateByIdArgs = {
  id: Scalars['SectionExerciseTemplateId']['input'];
};


export type QuerySubtitleGenerationJobByIdArgs = {
  id: Scalars['SubtitleGenerationJobId']['input'];
};


export type QuerySubtitleGenerationJobByVideoIdArgs = {
  videoId: Scalars['Int']['input'];
};


export type QueryTagByIdArgs = {
  id: Scalars['TagId']['input'];
};


export type QueryUploadFileDetailsArgs = {
  input?: InputMaybe<UploadFileInput>;
};


export type QueryUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVideoByIdArgs = {
  id: Scalars['Int']['input'];
};

export type RangedMetric = {
  __typename?: 'RangedMetric';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  single?: Maybe<Scalars['Float']['output']>;
};

export type Resource = {
  __typename?: 'Resource';
  challenges?: Maybe<Array<Challenge>>;
  content?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  gymStructures?: Maybe<Array<GymStructureTable>>;
  id: Scalars['ResourceId']['output'];
  image?: Maybe<Image>;
  resourceLists?: Maybe<Array<ResourceList>>;
  sections?: Maybe<Array<ResourceSection>>;
  status: ResourceStatus;
  title: Scalars['String']['output'];
};


export type ResourceSectionsArgs = {
  orderBy?: InputMaybe<ResourceSectionOrderBy>;
};

export type ResourceCondition = {
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  status?: InputMaybe<Array<ResourceStatus>>;
};

export type ResourceInput = {
  id: Scalars['ResourceId']['input'];
};

export type ResourceList = {
  __typename?: 'ResourceList';
  content?: Maybe<Scalars['String']['output']>;
  gymStructures?: Maybe<Array<GymStructureTable>>;
  id: Scalars['ResourceListId']['output'];
  image?: Maybe<Image>;
  resourceLists?: Maybe<Array<ResourceList>>;
  resources?: Maybe<Array<Resource>>;
  status: ResourceListStatus;
  title: Scalars['String']['output'];
};

export type ResourceListCondition = {
  gymStructures?: InputMaybe<Array<GymStructureInput>>;
  status?: InputMaybe<Array<ResourceListStatus>>;
};

export type ResourceListInput = {
  id: Scalars['ResourceListId']['input'];
};

export enum ResourceListStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  TESTING = 'TESTING'
}

export type ResourceSection = {
  __typename?: 'ResourceSection';
  componentAlignment: ComponentAlignment;
  content?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  documents?: Maybe<Array<Document>>;
  id: Scalars['ResourceSectionId']['output'];
  images?: Maybe<Array<Image>>;
  links?: Maybe<Array<Link>>;
  resource?: Maybe<Resource>;
  title: Scalars['String']['output'];
  videos?: Maybe<Array<Video>>;
};

export type ResourceSectionCondition = {
  resource?: InputMaybe<ResourceInput>;
};

export type ResourceSectionInput = {
  id: Scalars['ResourceSectionId']['input'];
};

export enum ResourceSectionOrderBy {
  CREATED_AT = 'CREATED_AT',
  DISPLAY_ORDER = 'DISPLAY_ORDER'
}

export enum ResourceStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  TESTING = 'TESTING'
}

export type SaveLessonByIdInput = {
  user: UserInput;
};

export type SectionExercise = {
  __typename?: 'SectionExercise';
  description?: Maybe<Scalars['String']['output']>;
  detailedMetrics: SectionExerciseMetrics;
  displayOrder: Scalars['Int']['output'];
  /** @deprecated Use detailedMetrics instead */
  distance?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  exercise: Exercise;
  group?: Maybe<SectionExerciseGroup>;
  id: Scalars['SectionExerciseId']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use detailedMetrics instead */
  repetitions?: Maybe<Scalars['Int']['output']>;
  rpe?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use detailedMetrics instead */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type SectionExerciseGroup = {
  __typename?: 'SectionExerciseGroup';
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['Float']['output'];
  id: Scalars['SectionExerciseGroupId']['output'];
  lessonSection?: Maybe<LessonSection>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  repeatTimes?: Maybe<Scalars['Int']['output']>;
  sectionExerciseGroupTemplate?: Maybe<SectionExerciseGroupTemplate>;
  sectionExerciseGroups?: Maybe<Array<SectionExerciseGroup>>;
  sectionExercises?: Maybe<Array<SectionExercise>>;
  showTitle: Scalars['Boolean']['output'];
};

export type SectionExerciseGroupInput = {
  id: Scalars['SectionExerciseGroupId']['input'];
};

export enum SectionExerciseGroupOrderBy {
  CREATED_AT = 'CREATED_AT',
  DISPLAY_ORDER = 'DISPLAY_ORDER'
}

export type SectionExerciseGroupTemplate = {
  __typename?: 'SectionExerciseGroupTemplate';
  description?: Maybe<Scalars['String']['output']>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  format: LessonSectionFormat;
  hideDescriptionField: Scalars['Boolean']['output'];
  hideTitleField: Scalars['Boolean']['output'];
  id: Scalars['SectionExerciseGroupTemplateId']['output'];
  lessonSectionTemplate?: Maybe<LessonSectionTemplate>;
  name?: Maybe<Scalars['String']['output']>;
  sectionExerciseGroupTemplates?: Maybe<Array<SectionExerciseGroupTemplate>>;
  sectionExerciseTemplates?: Maybe<Array<SectionExerciseTemplate>>;
};

export type SectionExerciseGroupTemplateInput = {
  id: Scalars['SectionExerciseGroupTemplateId']['input'];
};

export type SectionExerciseGroupWithDisplayOrderInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['SectionExerciseGroupId']['input'];
};

export type SectionExerciseInput = {
  id: Scalars['SectionExerciseId']['input'];
};

export type SectionExerciseMetrics = {
  __typename?: 'SectionExerciseMetrics';
  distance: RangedMetric;
  repetitions: RangedMetric;
  weight: RangedMetric;
};

export type SectionExerciseTemplate = {
  __typename?: 'SectionExerciseTemplate';
  description?: Maybe<Scalars['String']['output']>;
  exercise?: Maybe<Exercise>;
  id: Scalars['SectionExerciseTemplateId']['output'];
  sectionExerciseGroupTemplate?: Maybe<SectionExerciseGroupTemplate>;
};

export type SectionExerciseTemplateInput = {
  id: Scalars['SectionExerciseTemplateId']['input'];
};

export type SelectAllArgs = {
  direction?: InputMaybe<SelectDirection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export enum SelectDirection {
  asc = 'asc',
  desc = 'desc'
}

export type StartProgressivePlanInput = {
  progressivePlanId: Scalars['ProgressivePlanId']['input'];
};

export type Subtitle = {
  __typename?: 'Subtitle';
  id: Scalars['SubtitleId']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  language: Language;
  signedUrl?: Maybe<Scalars['URL']['output']>;
  uploadDetails?: Maybe<MediaUploadDetails>;
  video: Video;
};


export type SubtitleUploadDetailsArgs = {
  extension: SubtitleFileExtensions;
};

export enum SubtitleFileExtensions {
  VTT = 'VTT'
}

export type SubtitleGenerationJob = {
  __typename?: 'SubtitleGenerationJob';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISODateTime']['output'];
  id: Scalars['SubtitleGenerationJobId']['output'];
  status: SubtitleGenerationStatus;
  updatedAt: Scalars['ISODateTime']['output'];
  video: Video;
  videoId: Scalars['Int']['output'];
};

export enum SubtitleGenerationStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING'
}

export enum SupportedFileExtensions {
  JPEG = 'JPEG',
  JPG = 'JPG',
  MP4 = 'MP4',
  PDF = 'PDF',
  PNG = 'PNG'
}

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['TagId']['output'];
  lessons?: Maybe<Array<Lesson>>;
  name: Scalars['String']['output'];
};

export type TagInput = {
  id: Scalars['TagId']['input'];
};

export type UncompleteLessonByIdInput = {
  user: UserInput;
};

export type UnsaveLessonByIdInput = {
  user: UserInput;
};

export type UploadFileInput = {
  extension: SupportedFileExtensions;
  type: FileType;
};

export type User = {
  __typename?: 'User';
  /** Whether the user's account is active or disabled */
  active: Scalars['Boolean']['output'];
  banners: Array<Banner>;
  completedLessons?: Maybe<Array<Lesson>>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gym: Gym;
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  permissions: UserPermissions;
  preferredLanguage?: Maybe<Language>;
  profileImage?: Maybe<Image>;
  savedLessons?: Maybe<Array<Lesson>>;
  type: UserType;
  userRole?: Maybe<UserRole>;
};

export type UserCondition = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type UserInput = {
  id: Scalars['Int']['input'];
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  canAccessMultiscreen: Scalars['Boolean']['output'];
  canAccessPersonalisedHomescreen: Scalars['Boolean']['output'];
  canAccessWorkoutBuilder: Scalars['Boolean']['output'];
  canManageGym: Scalars['Boolean']['output'];
};

export enum UserRole {
  BUSINESS_OWNER = 'BUSINESS_OWNER',
  CHAIN_MANAGER = 'CHAIN_MANAGER',
  GYM_COACH = 'GYM_COACH',
  GYM_MANAGER = 'GYM_MANAGER',
  GYM_OWNER = 'GYM_OWNER',
  HEAD_OF_PROGRAMMING = 'HEAD_OF_PROGRAMMING',
  LOCATION_MANAGER = 'LOCATION_MANAGER',
  MARKETING_MANAGER = 'MARKETING_MANAGER',
  PERFORMANCE_COACH = 'PERFORMANCE_COACH'
}

export enum UserType {
  TRAINEE = 'TRAINEE',
  TRAINER = 'TRAINER'
}

export type Video = {
  __typename?: 'Video';
  allSubtitles?: Maybe<Array<Subtitle>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['URL']['output']>;
  subtitles?: Maybe<Subtitle>;
  thumbnail?: Maybe<Image>;
  uploadDetails?: Maybe<MediaUploadDetails>;
  url?: Maybe<Scalars['URL']['output']>;
};


export type VideoUploadDetailsArgs = {
  extension: VideoFileExtensions;
};

export type VideoCondition = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoFileExtensions {
  MP4 = 'MP4'
}

export type VideoInput = {
  id: Scalars['Int']['input'];
};

export type WorkoutDescription = {
  __typename?: 'WorkoutDescription';
  cooldownTime?: Maybe<Scalars['Int']['output']>;
  rpe?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  warmupTime?: Maybe<Scalars['Int']['output']>;
  workoutTime?: Maybe<Scalars['Int']['output']>;
};

export type ChallengeFragmentFragment = { __typename?: 'Challenge', id: any, title: string, challengeType: ChallengeType, shortDescription?: string | null, longDescription?: string | null, createdAt: any, updatedAt: any, notes?: string | null, ctaImage?: { __typename?: 'Image', signedUrl?: any | null } | null, challengeImage?: { __typename?: 'Image', signedUrl?: any | null } | null, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, sections?: Array<{ __typename?: 'LessonSection', id: any, format: LessonSectionFormat, duration: number, description?: string | null, notes?: string | null, name: string, isRotational: boolean, isMain: boolean, workTime?: number | null, restTime?: number | null, rounds: number, lessonSectionTemplate?: { __typename?: 'LessonSectionTemplate', id: any, format: LessonSectionFormat, workTime?: number | null, restTime?: number | null, rounds?: number | null, hideDescriptionField: boolean, hideTitleField: boolean, hideWorkRestField: boolean } | null, sectionExerciseGroups?: Array<{ __typename?: 'SectionExerciseGroup', id: any, name: string, description?: string | null, duration: number, showTitle: boolean, notes?: string | null, sectionExercises?: Array<{ __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } }> | null, sectionExerciseGroups?: Array<{ __typename?: 'SectionExerciseGroup', id: any, name: string, description?: string | null, duration: number, showTitle: boolean, notes?: string | null, sectionExercises?: Array<{ __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } }> | null }> | null, sectionExerciseGroupTemplate?: { __typename?: 'SectionExerciseGroupTemplate', id: any, format: LessonSectionFormat } | null }> | null }> | null, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, resourcePage?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null };

export type CollectionListFragmentFragment = { __typename?: 'CollectionList', id: any, title: string, collections?: Array<{ __typename?: 'Collection', id: any, title: string, lessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, isCompleted: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null }> | null }> | null };

export type CollectionFragmentFragment = { __typename?: 'Collection', id: any, title: string, longDescription?: string | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, lessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, isCompleted: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null }> | null, collectionList?: { __typename?: 'CollectionList', id: any, title: string, collections?: Array<{ __typename?: 'Collection', id: any, title: string, lessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, isCompleted: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null }> | null }> | null } | null };

export type ConceptFragmentFragment = { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean };

export type ExerciseFragmentFragment = { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null };

export type LessonOverviewDetailsFragmentFragment = { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> };

export type LessonSectionsFragmentFragment = { __typename?: 'LessonSection', id: any, format: LessonSectionFormat, duration: number, description?: string | null, notes?: string | null, name: string, isRotational: boolean, isMain: boolean, workTime?: number | null, restTime?: number | null, rounds: number, lessonSectionTemplate?: { __typename?: 'LessonSectionTemplate', id: any, format: LessonSectionFormat, workTime?: number | null, restTime?: number | null, rounds?: number | null, hideDescriptionField: boolean, hideTitleField: boolean, hideWorkRestField: boolean } | null, sectionExerciseGroups?: Array<{ __typename?: 'SectionExerciseGroup', id: any, name: string, description?: string | null, duration: number, showTitle: boolean, notes?: string | null, sectionExercises?: Array<{ __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } }> | null, sectionExerciseGroups?: Array<{ __typename?: 'SectionExerciseGroup', id: any, name: string, description?: string | null, duration: number, showTitle: boolean, notes?: string | null, sectionExercises?: Array<{ __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } }> | null }> | null, sectionExerciseGroupTemplate?: { __typename?: 'SectionExerciseGroupTemplate', id: any, format: LessonSectionFormat } | null }> | null };

export type ProgressivePlanBlockFragmentFragment = { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null };

export type ProgressivePlanInstanceFragmentFragment = { __typename?: 'ProgressivePlanInstance', id: any, startedAt: any, cancelledAt?: any | null, timezone: string, status: ProgressivePlanInstanceStatus, gym: { __typename?: 'Gym', id: number, name: string }, progressivePlan: { __typename?: 'ProgressivePlan', id: any, name: string, longDescription?: string | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, overviewVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null, resource?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null, blocks?: Array<{ __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null }, currentBlock?: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } | null, currentWeek?: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, notes?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number }, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null } | null, todaysWorkout?: { __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number } } } } | null, upcomingWorkouts: Array<{ __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string } } } }> };

export type ProgressivePlanFragmentFragment = { __typename?: 'ProgressivePlan', id: any, name: string, longDescription?: string | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, overviewVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null, resource?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null, blocks?: Array<{ __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null };

export type ResourceListFragmentFragment = { __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null }> | null };

export type NestedResourceListFragmentFragment = { __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null };

export type ResourceWithSectionsFragmentFragment = { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null };

export type ResourceFragmentFragment = { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null };

export type SectionExerciseFragmentFragment = { __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } };

export type CheckOnBoardingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CheckOnBoardingQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: number, gym: { __typename?: 'Gym', id: number, structure?: GymStructure | null, type?: { __typename?: 'GymType', id: number } | null, equipment?: Array<{ __typename?: 'Equipment', id: number }> | null, gymStructure?: { __typename?: 'GymStructureTable', name: string } | null } } | null };

export type ActiveTrainingPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveTrainingPlansQuery = { __typename?: 'Query', allProgressivePlanInstances?: { __typename?: 'GymProgressivePlanInstances', planInstances: Array<{ __typename?: 'ProgressivePlanInstance', id: any, startedAt: any, cancelledAt?: any | null, timezone: string, status: ProgressivePlanInstanceStatus, gym: { __typename?: 'Gym', id: number, name: string }, progressivePlan: { __typename?: 'ProgressivePlan', id: any, name: string, longDescription?: string | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, overviewVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null, resource?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null, blocks?: Array<{ __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null }, currentBlock?: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } | null, currentWeek?: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, notes?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number }, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null } | null, todaysWorkout?: { __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number } } } } | null, upcomingWorkouts: Array<{ __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string } } } }> }> } | null };

export type ChallengeQueryVariables = Exact<{
  id: Scalars['ChallengeId']['input'];
}>;


export type ChallengeQuery = { __typename?: 'Query', challenge?: { __typename?: 'Challenge', id: any, title: string, challengeType: ChallengeType, shortDescription?: string | null, longDescription?: string | null, createdAt: any, updatedAt: any, notes?: string | null, ctaImage?: { __typename?: 'Image', signedUrl?: any | null } | null, challengeImage?: { __typename?: 'Image', signedUrl?: any | null } | null, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, sections?: Array<{ __typename?: 'LessonSection', id: any, format: LessonSectionFormat, duration: number, description?: string | null, notes?: string | null, name: string, isRotational: boolean, isMain: boolean, workTime?: number | null, restTime?: number | null, rounds: number, lessonSectionTemplate?: { __typename?: 'LessonSectionTemplate', id: any, format: LessonSectionFormat, workTime?: number | null, restTime?: number | null, rounds?: number | null, hideDescriptionField: boolean, hideTitleField: boolean, hideWorkRestField: boolean } | null, sectionExerciseGroups?: Array<{ __typename?: 'SectionExerciseGroup', id: any, name: string, description?: string | null, duration: number, showTitle: boolean, notes?: string | null, sectionExercises?: Array<{ __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } }> | null, sectionExerciseGroups?: Array<{ __typename?: 'SectionExerciseGroup', id: any, name: string, description?: string | null, duration: number, showTitle: boolean, notes?: string | null, sectionExercises?: Array<{ __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } }> | null }> | null, sectionExerciseGroupTemplate?: { __typename?: 'SectionExerciseGroupTemplate', id: any, format: LessonSectionFormat } | null }> | null }> | null, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, resourcePage?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null } | null };

export type ChallengeUserResourcesQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  resourceListId: Scalars['ResourceListId']['input'];
}>;


export type ChallengeUserResourcesQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, permissions: { __typename?: 'UserPermissions', canAccessPersonalisedHomescreen: boolean, canAccessWorkoutBuilder: boolean, canAccessMultiscreen: boolean } } | null, resourceList?: { __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null }> | null } | null };

export type CollectionQueryVariables = Exact<{
  id: Scalars['CollectionId']['input'];
  filter?: InputMaybe<LessonCondition>;
}>;


export type CollectionQuery = { __typename?: 'Query', collection?: { __typename?: 'Collection', id: any, title: string, longDescription?: string | null, resource?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, lessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, isCompleted: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null }> | null, collectionList?: { __typename?: 'CollectionList', id: any, title: string, collections?: Array<{ __typename?: 'Collection', id: any, title: string, lessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, isCompleted: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null }> | null }> | null } | null } | null };

export type HomePageQueryVariables = Exact<{
  date: Scalars['ISODateTime']['input'];
  dateRange: DateRange;
  userId: Scalars['Int']['input'];
  resourceListId: Scalars['ResourceListId']['input'];
}>;


export type HomePageQuery = { __typename?: 'Query', wotd?: Array<{ __typename?: 'LessonSchedule', id: any, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null, weeklyWorkouts?: Array<{ __typename?: 'LessonSchedule', id: any, scheduledAt: any, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null, user?: { __typename?: 'User', id: number, firstName: string, email: string, type: UserType, userRole?: UserRole | null, preferredLanguage?: { __typename?: 'Language', code: string, name: string } | null, savedLessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> }> | null, gym: { __typename?: 'Gym', id: number, name: string, country?: CountryCode | null, gymStructure?: { __typename?: 'GymStructureTable', name: string } | null, type?: { __typename?: 'GymType', id: number, name: string } | null }, banners: Array<{ __typename?: 'Banner', id: any, title: string, description: string, link?: string | null, activeFrom: any, activeTo: any, gymStructures: Array<GymStructure>, image: { __typename?: 'Image', id: number, signedUrl?: any | null }, mobileImage?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }>, permissions: { __typename?: 'UserPermissions', canAccessPersonalisedHomescreen: boolean, canAccessWorkoutBuilder: boolean, canAccessMultiscreen: boolean } } | null, resourceList?: { __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null }> | null } | null, progressivePlanInstances?: { __typename?: 'GymProgressivePlanInstances', planInstances: Array<{ __typename?: 'ProgressivePlanInstance', id: any, startedAt: any, cancelledAt?: any | null, timezone: string, status: ProgressivePlanInstanceStatus, gym: { __typename?: 'Gym', id: number, name: string }, progressivePlan: { __typename?: 'ProgressivePlan', id: any, name: string, longDescription?: string | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, overviewVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null, resource?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null, blocks?: Array<{ __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null }, currentBlock?: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } | null, currentWeek?: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, notes?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number }, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null } | null, todaysWorkout?: { __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number } } } } | null, upcomingWorkouts: Array<{ __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string } } } }> }> } | null, progressivePlans?: { __typename?: 'PaginatedProgressivePlans', nodes?: Array<{ __typename?: 'ProgressivePlan', id: any }> | null } | null };

export type LibraryPageQueryVariables = Exact<{
  collectionListId: Scalars['CollectionListId']['input'];
}>;


export type LibraryPageQuery = { __typename?: 'Query', collectionList?: { __typename?: 'CollectionList', id: any, title: string, collections?: Array<{ __typename?: 'Collection', id: any, title: string, shortDescription?: string | null, longDescription?: string | null, displayOrder?: number | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null }> | null } | null, challenges?: { __typename?: 'PaginatedChallenges', nodes?: Array<{ __typename?: 'Challenge', id: any, lesson?: { __typename?: 'Lesson', concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null } | null }> | null } | null, progressivePlanInstances?: { __typename?: 'GymProgressivePlanInstances', planInstances: Array<{ __typename?: 'ProgressivePlanInstance', id: any, startedAt: any, cancelledAt?: any | null, timezone: string, status: ProgressivePlanInstanceStatus, gym: { __typename?: 'Gym', id: number, name: string }, progressivePlan: { __typename?: 'ProgressivePlan', id: any, name: string, longDescription?: string | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, overviewVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null, resource?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null, blocks?: Array<{ __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null }, currentBlock?: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } | null, currentWeek?: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, notes?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number }, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null } | null, todaysWorkout?: { __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number } } } } | null, upcomingWorkouts: Array<{ __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string } } } }> }> } | null, progressivePlans?: { __typename?: 'PaginatedProgressivePlans', nodes?: Array<{ __typename?: 'ProgressivePlan', id: any }> | null } | null };

export type EquipmentsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type EquipmentsQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: number, gym: { __typename?: 'Gym', id: number }, permissions: { __typename?: 'UserPermissions', canManageGym: boolean } } | null, allEquipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null };

export type PatchGymEquipmentsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PatchGymByIdInput;
}>;


export type PatchGymEquipmentsMutation = { __typename?: 'Mutation', patchGymById: { __typename?: 'Gym', id: number, equipment?: Array<{ __typename?: 'Equipment', id: number }> | null } };

export type GymsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GymsQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: number, gym: { __typename?: 'Gym', id: number }, permissions: { __typename?: 'UserPermissions', canManageGym: boolean } } | null, allGymTypes?: Array<{ __typename?: 'GymType', id: number, name: string }> | null };

export type PatchGymTypeByGymMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PatchGymByIdInput;
}>;


export type PatchGymTypeByGymMutation = { __typename?: 'Mutation', patchGymById: { __typename?: 'Gym', id: number, type?: { __typename?: 'GymType', id: number } | null } };

export type AllEquipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEquipmentsQuery = { __typename?: 'Query', allEquipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null };

export type PatchGymMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PatchGymByIdInput;
}>;


export type PatchGymMutation = { __typename?: 'Mutation', patchGymById: { __typename?: 'Gym', id: number, type?: { __typename?: 'GymType', id: number, name: string } | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null } };

export type PatchUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PatchUserByIdInput;
}>;


export type PatchUserMutation = { __typename?: 'Mutation', patchUserById: { __typename?: 'User', id: number, email: string, firstName: string, lastName: string } };

export type ProfilePageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProfilePageQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string, type: UserType, gym: { __typename?: 'Gym', id: number, name: string, type?: { __typename?: 'GymType', id: number, name: string } | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null }, permissions: { __typename?: 'UserPermissions', canManageGym: boolean }, savedLessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> }> | null, completedLessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> }> | null } | null, allEquipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, allGymTypes?: Array<{ __typename?: 'GymType', id: number, name: string }> | null };

export type CancelProgressivePlanMutationVariables = Exact<{
  input: CancelProgressivePlanInput;
}>;


export type CancelProgressivePlanMutation = { __typename?: 'Mutation', cancelProgressivePlan?: { __typename?: 'ProgressivePlanInstance', id: any } | null };

export type ProgressivePlanInstanceQueryVariables = Exact<{
  id: Scalars['ProgressivePlanInstanceId']['input'];
  resourceListId: Scalars['ResourceListId']['input'];
}>;


export type ProgressivePlanInstanceQuery = { __typename?: 'Query', planInstance?: { __typename?: 'ProgressivePlanInstance', id: any, startedAt: any, cancelledAt?: any | null, timezone: string, status: ProgressivePlanInstanceStatus, gym: { __typename?: 'Gym', id: number, name: string }, progressivePlan: { __typename?: 'ProgressivePlan', id: any, name: string, longDescription?: string | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, overviewVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null, resource?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null, blocks?: Array<{ __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null }, currentBlock?: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } | null, currentWeek?: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, notes?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number }, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null } | null, todaysWorkout?: { __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number } } } } | null, upcomingWorkouts: Array<{ __typename?: 'ProgressivePlanScheduleWorkout', id: any, scheduledAt: any, progressivePlanWorkout: { __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, progressivePlanWeek: { __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, progressivePlanBlock: { __typename?: 'ProgressivePlanBlock', id: any, name: string } } } }> } | null, resourceList?: { __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null }> | null } | null };

export type StartProgressivePlanMutationVariables = Exact<{
  input: StartProgressivePlanInput;
}>;


export type StartProgressivePlanMutation = { __typename?: 'Mutation', startProgressivePlan: { __typename?: 'ProgressivePlanInstance', id: any } };

export type ProgressivePlanQueryVariables = Exact<{
  id: Scalars['ProgressivePlanId']['input'];
  userId: Scalars['Int']['input'];
}>;


export type ProgressivePlanQuery = { __typename?: 'Query', progressivePlanById?: { __typename?: 'ProgressivePlan', id: any, name: string, longDescription?: string | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, overviewVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null, resource?: { __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null, blocks?: Array<{ __typename?: 'ProgressivePlanBlock', id: any, name: string, displayOrder: number, introText?: string | null, weeks?: Array<{ __typename?: 'ProgressivePlanWeek', id: any, weekNumber: number, title?: string | null, shortDescription?: string | null, workouts?: Array<{ __typename?: 'ProgressivePlanWorkout', id: any, dayOfWeek: number, lesson?: { __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null }> | null }> | null, desktopImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, mobileImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, introVideo?: { __typename?: 'Video', id: number, url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null } | null, userById?: { __typename?: 'User', gym: { __typename?: 'Gym', activeProgressivePlans: Array<{ __typename?: 'ProgressivePlanInstance', id: any, progressivePlan: { __typename?: 'ProgressivePlan', id: any } }> } } | null };

export type GetResourceListQueryVariables = Exact<{
  resourceListId: Scalars['ResourceListId']['input'];
}>;


export type GetResourceListQuery = { __typename?: 'Query', resourceListById?: { __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null }> | null } | null };

export type GetRootResourceListQueryVariables = Exact<{
  resourceListId: Scalars['ResourceListId']['input'];
}>;


export type GetRootResourceListQuery = { __typename?: 'Query', resourceListById?: { __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null, resources?: Array<{ __typename?: 'Resource', id: any, title: string, content?: string | null, status: ResourceStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null, resourceLists?: Array<{ __typename?: 'ResourceList', id: any, title: string, content?: string | null, status: ResourceListStatus, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null }> | null } | null };

export type ResourcePageQueryVariables = Exact<{
  id: Scalars['ResourceId']['input'];
}>;


export type ResourcePageQuery = { __typename?: 'Query', resourceById?: { __typename?: 'Resource', id: any, ctaLink?: string | null, ctaLabel?: string | null, title: string, status: ResourceStatus, content?: string | null, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, sections?: Array<{ __typename?: 'ResourceSection', id: any, title: string, content?: string | null, ctaLink?: string | null, ctaLabel?: string | null, componentAlignment: ComponentAlignment, images?: Array<{ __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null }> | null, videos?: Array<{ __typename?: 'Video', id: number, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', signedUrl?: any | null } | null, subtitles?: { __typename?: 'Subtitle', id: any, signedUrl?: any | null, language: { __typename?: 'Language', code: string } } | null }> | null, documents?: Array<{ __typename?: 'Document', id: any, signedUrl?: any | null }> | null, links?: Array<{ __typename?: 'Link', id: any, url: any }> | null }> | null } | null };

export type ResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourcesQuery = { __typename?: 'Query', allResources?: Array<{ __typename?: 'Resource', id: any, title: string, status: ResourceStatus, content?: string | null, image?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null }> | null };

export type TrainingPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type TrainingPlansQuery = { __typename?: 'Query', allProgressivePlans?: { __typename?: 'PaginatedProgressivePlans', nodes?: Array<{ __typename?: 'ProgressivePlan', id: any, name: string, longDescription?: string | null, ctaImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, bannerImage?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null }> | null } | null };

export type CompleteLessonByIdMutationVariables = Exact<{
  id: Scalars['LessonId']['input'];
  input: CompleteLessonByIdInput;
}>;


export type CompleteLessonByIdMutation = { __typename?: 'Mutation', completeLessonById: { __typename?: 'Lesson', id: any, isCompleted: boolean } };

export type UncompleteLessonByIdMutationVariables = Exact<{
  id: Scalars['LessonId']['input'];
  input: UncompleteLessonByIdInput;
}>;


export type UncompleteLessonByIdMutation = { __typename?: 'Mutation', uncompleteLessonById: { __typename?: 'Lesson', id: any, isCompleted: boolean } };

export type SaveLessonByIdMutationVariables = Exact<{
  id: Scalars['LessonId']['input'];
  input: SaveLessonByIdInput;
}>;


export type SaveLessonByIdMutation = { __typename?: 'Mutation', saveLessonById: { __typename?: 'Lesson', id: any, isSaved: boolean } };

export type UnsaveLessonByIdMutationVariables = Exact<{
  id: Scalars['LessonId']['input'];
  input: UnsaveLessonByIdInput;
}>;


export type UnsaveLessonByIdMutation = { __typename?: 'Mutation', unsaveLessonById: { __typename?: 'Lesson', id: any, isSaved: boolean } };

export type WorkoutPageQueryVariables = Exact<{
  id: Scalars['LessonId']['input'];
  userId: Scalars['Int']['input'];
}>;


export type WorkoutPageQuery = { __typename?: 'Query', lessonById?: { __typename?: 'Lesson', id: any, migratedAt?: any | null, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, collections?: Array<{ __typename?: 'Collection', id: any, title: string }> | null, sections?: Array<{ __typename?: 'LessonSection', id: any, format: LessonSectionFormat, duration: number, description?: string | null, notes?: string | null, name: string, isRotational: boolean, isMain: boolean, workTime?: number | null, restTime?: number | null, rounds: number, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, signedUrl?: any | null } | null } | null, lessonSectionTemplate?: { __typename?: 'LessonSectionTemplate', id: any, format: LessonSectionFormat, workTime?: number | null, restTime?: number | null, rounds?: number | null } | null, sectionExerciseGroups?: Array<{ __typename?: 'SectionExerciseGroup', id: any, name: string, description?: string | null, duration: number, showTitle: boolean, notes?: string | null, sectionExercises?: Array<{ __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } }> | null, sectionExerciseGroups?: Array<{ __typename?: 'SectionExerciseGroup', id: any, name: string, description?: string | null, duration: number, showTitle: boolean, notes?: string | null, sectionExercises?: Array<{ __typename?: 'SectionExercise', id: any, description?: string | null, duration?: number | null, notes?: string | null, rpe?: number | null, weight?: number | null, repetitions?: number | null, distance?: number | null, detailedMetrics: { __typename?: 'SectionExerciseMetrics', distance: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, repetitions: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null }, weight: { __typename?: 'RangedMetric', min?: number | null, max?: number | null, single?: number | null } }, exercise: { __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, alternativeExercises?: Array<{ __typename?: 'Exercise', id: any, name: string, description: string, duration?: number | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null }> | null, video?: { __typename?: 'Video', url?: any | null, signedUrl?: any | null, thumbnail?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null } | null } }> | null }> | null, sectionExerciseGroupTemplate?: { __typename?: 'SectionExerciseGroupTemplate', id: any, format: LessonSectionFormat } | null }> | null }> | null, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> } | null, user?: { __typename?: 'User', permissions: { __typename?: 'UserPermissions', canAccessWorkoutBuilder: boolean } } | null };

export type SaveLessonByIdClassCardMutationVariables = Exact<{
  id: Scalars['LessonId']['input'];
  input: SaveLessonByIdInput;
}>;


export type SaveLessonByIdClassCardMutation = { __typename?: 'Mutation', saveLessonById: { __typename?: 'Lesson', id: any, isSaved: boolean } };

export type UnsaveLessonByIdClassCardMutationVariables = Exact<{
  id: Scalars['LessonId']['input'];
  input: UnsaveLessonByIdInput;
}>;


export type UnsaveLessonByIdClassCardMutation = { __typename?: 'Mutation', unsaveLessonById: { __typename?: 'Lesson', id: any, isSaved: boolean } };

export type LanguagePickerWrapperQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagePickerWrapperQuery = { __typename?: 'Query', allLanguages?: Array<{ __typename?: 'Language', code: string, name: string, translationAutomation: { __typename?: 'LanguageTranslationAutomation', resources: boolean } }> | null };

export type UpdatePreferredLanguageMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
}>;


export type UpdatePreferredLanguageMutation = { __typename?: 'Mutation', patchUserById: { __typename?: 'User', id: number, preferredLanguage?: { __typename?: 'Language', code: string } | null } };

export type WeeklyWorkoutListWrapperQueryVariables = Exact<{
  filters?: InputMaybe<SelectAllArgs>;
}>;


export type WeeklyWorkoutListWrapperQuery = { __typename?: 'Query', lessonGroups?: { __typename?: 'PaginatedLessonGroups', totalCount: number, nodes?: Array<{ __typename?: 'LessonGroup', id: any, lessons?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> }> | null, weekInfo?: { __typename?: 'LessonGroupWeekInfo', number: number, from: any, to: any } | null }> | null } | null };

export type WorkoutListControllerQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkoutListControllerQuery = { __typename?: 'Query', allEquipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, allConcepts?: Array<{ __typename?: 'Concept', id: any, name: string }> | null };

export type WorkoutListWrapperQueryVariables = Exact<{
  lessonsCondition: LessonCondition;
  filters?: InputMaybe<SelectAllArgs>;
}>;


export type WorkoutListWrapperQuery = { __typename?: 'Query', lessons?: { __typename?: 'PaginatedLessons', totalCount: number, nodes?: Array<{ __typename?: 'Lesson', id: any, name: string, description: string, duration: number, intensity: number, isSaved: boolean, status: LessonStatus, isCompleted: boolean, apiOnly: boolean, classType: ClassType, collectionOnly: boolean, image?: { __typename?: 'Image', id: number, url?: any | null, signedUrl?: any | null } | null, trainers?: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> | null, equipment?: Array<{ __typename?: 'Equipment', id: number, name: string }> | null, concept: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean }, lessonConcept?: { __typename?: 'Concept', id: any, name: string, hiddenConcept: boolean } | null, gymStructures: Array<{ __typename?: 'GymStructureTable', id: string, name: string }> }> | null } | null, allConcepts?: Array<{ __typename?: 'Concept', id: any, name: string }> | null };


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "PaginatedResponse": [
      "PaginatedChallenges",
      "PaginatedCollectionLists",
      "PaginatedCollections",
      "PaginatedDocument",
      "PaginatedExercises",
      "PaginatedImages",
      "PaginatedLessonGroups",
      "PaginatedLessons",
      "PaginatedPlans",
      "PaginatedProgressivePlans",
      "PaginatedVideos"
    ]
  }
};
      export default result;
    